(function () {
  'use strict';

  var routes = window.routes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart'
  };

  function money(cents) {
    var n = cents / 100;
    var whole = Math.round(n * 100) / 100;
    var str =
      whole % 1 === 0
        ? whole.toLocaleString('en-US')
        : whole.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
    return '$' + str;
  }

  var fitHeaderName = function () {};

  /* ---- Header: contrast text over desktop heroes; name shortens only when it collides -- */
  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header || header.getAttribute('data-header-ready') === 'true') return;
    header.setAttribute('data-header-ready', 'true');

    var hero = null;
    if (document.body.classList.contains('template-product')) {
      hero = document.querySelector('[data-product-hero]');
    } else if (document.body.classList.contains('template-index') || document.querySelector('[data-home-hero]')) {
      hero = document.querySelector('[data-home-hero]');
    }
    var desktop = window.matchMedia('(min-width: 640px)');

    var lastY = window.scrollY || 0;
    var ticking = false;
    var hideAfter = 64;
    var contrastTargets = [
      header.querySelector('.site-header__shop'),
      header.querySelector('.site-header__name'),
      header.querySelector('.site-header__nav')
    ].filter(Boolean);
    var probes = {};
    var scratch = document.createElement('canvas');
    scratch.width = 1;
    scratch.height = 1;
    var scratchCtx = scratch.getContext('2d', { willReadFrequently: true });

    function heroPast() {
      if (!hero) return true;
      var headerH = header.getBoundingClientRect().bottom || header.offsetHeight || 60;
      return hero.getBoundingClientRect().bottom <= headerH;
    }

    function useOverlay() {
      return !!(hero && desktop.matches && !heroPast());
    }

    /* Longest lockup that clears Shop and About. Tighten tracking before the short name. */
    function nameFits() {
      var shop = header.querySelector('.site-header__shop');
      var name = header.querySelector('.site-header__name');
      var nav = header.querySelector('.site-header__nav');
      if (!shop || !name || !nav) return true;
      var gap = 8;
      var s = shop.getBoundingClientRect();
      var n = name.getBoundingClientRect();
      var v = nav.getBoundingClientRect();
      if (n.width < 2 || s.width < 2 || v.width < 2) return true;
      return n.left >= s.right + gap && n.right <= v.left - gap;
    }

    function fitName() {
      var modes = ['wide', 'mid', 'narrow'];
      header.classList.remove('is-name-tight');
      var chosen = 'narrow';
      var i;
      for (i = 0; i < modes.length; i++) {
        header.setAttribute('data-name', modes[i]);
        if (nameFits()) {
          chosen = modes[i];
          break;
        }
      }
      if (chosen === 'narrow') {
        header.setAttribute('data-name', 'mid');
        header.classList.add('is-name-tight');
        if (nameFits()) return;
        header.setAttribute('data-name', 'narrow');
        if (nameFits()) {
          header.classList.remove('is-name-tight');
          return;
        }
        header.classList.add('is-name-tight');
        return;
      }
      header.setAttribute('data-name', chosen);
    }
    fitHeaderName = fitName;

    function schedule() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var goingDown = y > lastY;
      header.classList.toggle('is-overlay', useOverlay());
      if (y <= hideAfter) header.classList.remove('is-hidden');
      else if (goingDown) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastY = y;
      syncHeaderContrast();
    }

    /* One color for the whole bar: white on a dark photo, black on a light one. */
    function syncHeaderContrast() {
      var measuring = header.classList.contains('is-overlay') && !header.classList.contains('is-hidden');
      if (!measuring) {
        header.classList.remove('is-on-light', 'is-on-dark');
        return;
      }
      var sum = 0;
      var n = 0;
      var lum;
      for (var i = 0; i < contrastTargets.length; i++) {
        lum = sampleLuminance(contrastTargets[i]);
        if (lum == null) return;
        sum += lum;
        n++;
      }
      if (!n) return;
      lum = sum / n;
      var onDark = header.classList.contains('is-on-dark');
      var onLight = header.classList.contains('is-on-light');
      if (!onDark && !onLight) onDark = lum < 0.18;
      else if (onDark) onDark = lum < 0.24;
      else onDark = lum < 0.14;
      header.classList.toggle('is-on-dark', onDark);
      header.classList.toggle('is-on-light', !onDark);
    }

    function sampleLuminance(el) {
      var rect = el.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return null;
      var cols = 3;
      var rows = rect.height > 36 ? 2 : 1;
      var sum = 0;
      var n = 0;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var rgb = colorBehind(
            rect.left + (rect.width * (c + 0.5)) / cols,
            rect.top + (rect.height * (r + 0.5)) / rows
          );
          if (!rgb) return null;
          sum += relativeLum(rgb[0], rgb[1], rgb[2]);
          n++;
        }
      }
      return n ? sum / n : null;
    }

    function colorBehind(x, y) {
      if (!document.elementsFromPoint) return null;
      var stack = document.elementsFromPoint(x, y);
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (el === header || header.contains(el)) continue;
        if (!isPainted(el)) continue;
        if (el.tagName === 'IMG') {
          var bmp = bitmapFor(el);
          if (bmp === false) continue;
          if (!bmp) return null;
          var px = pixelFromImage(el, bmp, x, y);
          if (px === false) return null;
          if (px) return px;
          continue;
        }
        var bg = parseColor(window.getComputedStyle(el).backgroundColor);
        if (bg) return bg;
      }
      return [255, 255, 255];
    }

    function isPainted(el) {
      var node = el;
      while (node && node !== document.documentElement) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        if (parseFloat(style.opacity) < 0.05) return false;
        node = node.parentElement;
      }
      return true;
    }

    function bitmapFor(displayImg) {
      var src = displayImg.currentSrc || displayImg.src;
      if (!src || !displayImg.complete || !displayImg.naturalWidth) return null;
      if (isSameOrigin(src)) return displayImg;
      var hit = probes[src];
      if (hit) {
        if (hit.failed) return false;
        return hit.img || null;
      }
      var probe = new Image();
      probes[src] = { img: null, failed: false };
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        probes[src].img = probe;
        schedule();
      };
      probe.onerror = function () {
        probes[src].failed = true;
        schedule();
      };
      probe.src = src;
      return null;
    }

    function isSameOrigin(url) {
      try {
        return new URL(url, window.location.href).origin === window.location.origin;
      } catch (e) {
        return false;
      }
    }

    function pixelFromImage(displayImg, bitmap, clientX, clientY) {
      var rect = displayImg.getBoundingClientRect();
      var nw = bitmap.naturalWidth;
      var nh = bitmap.naturalHeight;
      if (!nw || !nh || rect.width < 1 || rect.height < 1) return null;
      var style = window.getComputedStyle(displayImg);
      var fit = style.objectFit || 'fill';
      var pos = objectPositionFractions(style.objectPosition);
      var localX = clientX - rect.left;
      var localY = clientY - rect.top;
      var sx;
      var sy;
      if (fit === 'cover' || fit === 'contain' || fit === 'none' || fit === 'scale-down') {
        var scale;
        if (fit === 'contain') scale = Math.min(rect.width / nw, rect.height / nh);
        else if (fit === 'none') scale = 1;
        else if (fit === 'scale-down') scale = Math.min(1, Math.min(rect.width / nw, rect.height / nh));
        else scale = Math.max(rect.width / nw, rect.height / nh);
        var ox = (rect.width - nw * scale) * pos.x;
        var oy = (rect.height - nh * scale) * pos.y;
        sx = (localX - ox) / scale;
        sy = (localY - oy) / scale;
      } else {
        sx = (localX / rect.width) * nw;
        sy = (localY / rect.height) * nh;
      }
      var ix = Math.floor(sx);
      var iy = Math.floor(sy);
      if (ix < 0 || iy < 0 || ix >= nw || iy >= nh) return null;
      try {
        scratchCtx.clearRect(0, 0, 1, 1);
        scratchCtx.drawImage(bitmap, ix, iy, 1, 1, 0, 0, 1, 1);
        var data = scratchCtx.getImageData(0, 0, 1, 1).data;
        if (data[3] < 16) return null;
        return [data[0], data[1], data[2]];
      } catch (e) {
        scratch = document.createElement('canvas');
        scratch.width = 1;
        scratch.height = 1;
        scratchCtx = scratch.getContext('2d', { willReadFrequently: true });
        return false;
      }
    }

    function objectPositionFractions(value) {
      var parts = (value || '50% 50%').trim().split(/\s+/);
      if (parts.length === 1) parts.push('center');
      function axis(token) {
        if (token === 'left' || token === 'top') return 0;
        if (token === 'right' || token === 'bottom') return 1;
        if (token === 'center') return 0.5;
        if (token.indexOf('%') !== -1) return parseFloat(token) / 100;
        return 0.5;
      }
      return { x: axis(parts[0]), y: axis(parts[1]) };
    }

    function parseColor(str) {
      if (!str) return null;
      var m = str.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+%?))?\s*\)/);
      if (!m) return null;
      var alpha = 1;
      if (m[4] != null) {
        alpha = m[4].indexOf('%') !== -1 ? parseFloat(m[4]) / 100 : parseFloat(m[4]);
      }
      if (alpha < 0.35) return null;
      return [parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3])];
    }

    function relativeLum(r, g, b) {
      function lin(c) {
        c = c / 255;
        return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      fitName();
      schedule();
    }, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitName();
        schedule();
      });
    }
    if (desktop.addEventListener) desktop.addEventListener('change', function () {
      fitName();
      schedule();
    });

    fitName();
    update();

    if (hero) {
      hero.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', schedule);
      });
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(hero, {
          attributes: true,
          attributeFilter: ['class', 'hidden'],
          subtree: true
        });
      }
    }
  }
  /* ---- Grid columns (collection order → round-robin masonry) ------------ */
  function gridColumnCount() {
    if (window.matchMedia('(max-width: 199px)').matches) return 1;
    /* 2 cols when squished / tablet; 3 on desktop */
    if (window.matchMedia('(max-width: 1199px)').matches) return 2;
    return 3;
  }

  function layoutGridColumns() {
    var grid = document.querySelector('.grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    if (!cards.length) return;

    cards.sort(function (a, b) {
      return (
        parseInt(a.getAttribute('data-order') || '0', 10) -
        parseInt(b.getAttribute('data-order') || '0', 10)
      );
    });

    /* Square grid: cards are direct children — no column wrappers */
    if (grid.classList.contains('grid--square')) {
      grid.replaceChildren();
      cards.forEach(function (card) { grid.appendChild(card); });
      return;
    }

    var count = gridColumnCount();
    grid.replaceChildren();
    var cols = [];
    for (var c = 0; c < count; c++) {
      var col = document.createElement('div');
      col.className = 'grid__col';
      grid.appendChild(col);
      cols.push(col);
    }
    var visibleIndex = 0;
    cards.forEach(function (card) {
      if (card.classList.contains('is-hidden')) {
        cols[0].appendChild(card);
        return;
      }
      cols[visibleIndex % count].appendChild(card);
      visibleIndex++;
    });
  }

  var gridLayoutTimer;
  function scheduleGridLayout() {
    clearTimeout(gridLayoutTimer);
    gridLayoutTimer = setTimeout(function () {
      layoutGridColumns();
      refreshGridVisibleImages();
    }, 100);
  }

  /* ---- Grid: one screen loader until in-viewport photos are ready -------- */
  var gridLazyObserver;
  var gridWrapEl;
  var gridInitialLoadDone = false;
  var gridScrollBound = false;
  var gridScrollTimer;

  function getGridWrap() {
    if (!gridWrapEl) gridWrapEl = document.querySelector('.grid-wrap');
    return gridWrapEl;
  }

  function gridUsesMobileArt() {
    return window.matchMedia('(max-width: 639px)').matches;
  }

  function gridVisibleImage(card) {
    var art = card.querySelector('.card__img--art');
    var framed = card.querySelector('.card__img--framed');
    var simple = card.querySelector('[data-simple-mockup]');
    /* Square cards always prefer framed (shown on all viewports via CSS) */
    if (card.classList.contains('card--square')) return simple || framed || art;
    if (gridUsesMobileArt()) return art || simple || framed;
    return simple || framed || art;
  }

  /** Wait until every listed <img> has loaded (or errored), then run done. */
  function whenImagesReady(imgs, done) {
    var list = (imgs || []).filter(Boolean);
    if (!list.length) {
      done();
      return;
    }
    var left = list.length;
    function one() {
      left -= 1;
      if (left <= 0) done();
    }
    list.forEach(function (img) {
      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        one();
      }
      function retry() {
        if (img.getAttribute('data-retry') === '1') {
          finish();
          return;
        }
        img.setAttribute('data-retry', '1');
        img.loading = 'eager';
        var src = img.getAttribute('src');
        if (src) {
          img.removeAttribute('src');
          img.src = src;
        } else finish();
      }
      if (img.complete && img.naturalWidth) {
        finish();
        return;
      }
      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', retry, { once: true });
      /* Phones sometimes never fire load for cloned carousel images. */
      window.setTimeout(function () {
        if (settled) return;
        if (img.complete && img.naturalWidth) {
          finish();
          return;
        }
        if (!img.complete) return;
        retry();
      }, 4000);
    });
  }

  function armSimpleMockup(root) {
    if (!root || root.getAttribute('data-armed') === '1') return;
    root.setAttribute('data-armed', '1');
    var photo = root.querySelector('[data-simple-photo]');
    var frame = root.querySelector('[data-simple-frame]');
    whenImagesReady([photo, frame], function () {
      root.classList.add('is-ready');
      var media = root.closest('.card__media, .home-favorites__media, .product-related__media');
      if (media) media.classList.add('is-loaded');
      updateGridScreenLoader();
    });
  }

  function initSimpleMockups(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-simple-mockup]').forEach(armSimpleMockup);
  }

  function armProductDyn(node) {
    if (!node) return;
    var photo = node.querySelector('.product-dyn__photo');
    var frame = node.querySelector('.product-dyn__frame');
    var metal = node.classList.contains('is-metal');
    function mark() {
      node.classList.add('is-ready');
    }
    if (metal) {
      whenImagesReady([photo], mark);
      return;
    }
    whenImagesReady([photo, frame], mark);
  }

  function initProductDynReady(scope) {
    var root = scope || document;
    root.querySelectorAll('.product-dyn').forEach(armProductDyn);
  }

  function gridScreenCards() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.grid .card:not(.is-hidden)'),
      function (card) {
        var rect = card.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      }
    );
  }

  function gridImageIsReady(img) {
    if (!img) return false;
    if (img.hasAttribute('data-simple-mockup')) {
      return img.classList.contains('is-ready');
    }
    return img.classList.contains('is-loaded');
  }

  function updateGridScreenLoader() {
    var wrap = getGridWrap();
    if (!wrap || !wrap.querySelector('.grid-screen-loader')) return;

    var pending = 0;
    gridScreenCards().forEach(function (card) {
      var img = gridVisibleImage(card);
      if (img && !gridImageIsReady(img)) pending++;
    });

    var loader = wrap.querySelector('.grid-screen-loader');
    if (pending > 0) {
      wrap.classList.add('is-loading');
      if (loader) loader.setAttribute('aria-busy', 'true');
    } else {
      wrap.classList.remove('is-loading');
      if (loader) loader.setAttribute('aria-busy', 'false');
      if (!gridInitialLoadDone) {
        gridInitialLoadDone = true;
        wrap.classList.remove('is-loading-initial');
      }
    }
  }

  function markGridImageLoaded(img) {
    if (!img) return;
    img.classList.add('is-loaded');
    var media = img.closest('.card__media');
    if (media) media.classList.add('is-loaded');
    updateGridScreenLoader();
  }

  function loadGridImage(img) {
    if (!img || img.getAttribute('data-loaded') === '1') return;

    var src = img.getAttribute('data-src');
    if (!src) {
      markGridImageLoaded(img);
      return;
    }

    img.setAttribute('data-loaded', '1');
    updateGridScreenLoader();

    function done() {
      markGridImageLoaded(img);
    }

    img.src = src;

    if (img.complete) {
      done();
      return;
    }

    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function loadGridCard(card) {
    var target = gridVisibleImage(card);
    if (target && target.hasAttribute('data-simple-mockup')) {
      armSimpleMockup(target);
      /* Still kick art data-src so aspect / mobile fallback can resolve. */
      loadGridImage(card.querySelector('.card__img--art'));
      return;
    }
    loadGridImage(target);
  }

  function loadGridScreenBatch() {
    updateGridScreenLoader();
    gridScreenCards().forEach(loadGridCard);
    updateGridScreenLoader();
  }

  function observeOffscreenGridCards() {
    var cards = document.querySelectorAll('.grid .card:not(.is-hidden)');

    if (gridLazyObserver) gridLazyObserver.disconnect();

    if (!('IntersectionObserver' in window)) {
      cards.forEach(loadGridCard);
      return;
    }

    gridLazyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadGridCard(entry.target);
          gridLazyObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px' }
    );

    cards.forEach(function (card) {
      var rect = card.getBoundingClientRect();
      var onScreen = rect.top < window.innerHeight && rect.bottom > 0;
      if (!onScreen) gridLazyObserver.observe(card);
    });
  }

  function onGridScroll() {
    clearTimeout(gridScrollTimer);
    gridScrollTimer = setTimeout(loadGridScreenBatch, 80);
  }

  /* Square collection grid ships real <img src srcset loading=lazy>; the top
     rows load first, then the rest are promoted once the page is idle so
     scrolling never waits on the network. */
  function initSquareGridPreload() {
    var imgs = document.querySelectorAll('.grid--square img[loading="lazy"]');
    if (!imgs.length) return;
    function promote() {
      imgs.forEach(function (img) {
        img.loading = 'eager';
      });
    }
    function schedule() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(promote, { timeout: 2000 });
      else window.setTimeout(promote, 300);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  function initGridLazyLoad() {
    if (!document.querySelector('.grid .card')) return;
    if (document.querySelector('.grid--square')) {
      initSquareGridPreload();
      return;
    }
    if (!gridScrollBound) {
      gridScrollBound = true;
      window.addEventListener('scroll', onGridScroll, { passive: true });
    }
    loadGridScreenBatch();
    observeOffscreenGridCards();
  }

  function refreshGridVisibleImages() {
    if (document.querySelector('.grid--square')) return;
    observeOffscreenGridCards();
    loadGridScreenBatch();
  }

  /* Phones should navigate on tap without the desktop hover zoom. */
  function cardZoomEnabled() {
    return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 700px)').matches;
  }

  /* ---- Grid: framed hover (JS class — CSS hover:hover fails on many
       Windows touch laptops even when using a mouse) -------------------- */
  function initCardHover() {
    var cards = document.querySelectorAll('.card.card--has-framed');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.getAttribute('data-hover-bound') === '1') return;
      card.setAttribute('data-hover-bound', '1');

      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || !cardZoomEnabled()) return;
        card.classList.add('is-hovered');
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-hovered');
      });
      card.addEventListener('focusin', function () {
        if (!cardZoomEnabled()) return;
        card.classList.add('is-hovered');
      });
      card.addEventListener('focusout', function () {
        card.classList.remove('is-hovered');
      });
    });
  }

  /* ---- Light save deterrent (gallery / product photos) ----------------- */
  // Blocks casual right-click Save and drag-to-desktop. Not a hard lock —
  // screenshots and DevTools still work. Scoped to photo images only.
  function initImageSaveDeterrent() {
    var SELECTOR =
      'img.card__img--art, img.card__img--framed, .lightbox__img, .product__main-img, .product__thumb img, .product-zoom__img, .product-hero__img';

    function isProtected(el) {
      return !!(el && el.closest && el.closest(SELECTOR));
    }

    document.addEventListener('contextmenu', function (e) {
      if (isProtected(e.target)) e.preventDefault();
    });

    document.addEventListener('dragstart', function (e) {
      if (isProtected(e.target)) e.preventDefault();
    });

    document.addEventListener('selectstart', function (e) {
      if (isProtected(e.target)) e.preventDefault();
    });

    document.addEventListener('pointerdown', function (e) {
      if (!isProtected(e.target)) return;
      var selection = window.getSelection && window.getSelection();
      if (selection) selection.removeAllRanges();
    });
  }

  /* ---- Filter (centered toggle + single row) ---------------------------- */
  function initFilter() {
    var filter = document.querySelector('.grid-filter');
    if (!filter) return;
    var toggle = filter.querySelector('[data-filter-toggle]');
    var panel = filter.querySelector('[data-filter-panel]');
    var tagBtns = filter.querySelectorAll('.grid-filter__tag');
    var cards = document.querySelectorAll('.card');
    var empty = document.querySelector('.grid-empty');
    var activeType = '';
    var activePlace = '';
    var activeArtist = '';

    function cardTags(card) {
      return (card.getAttribute('data-tags') || '').split('|').filter(Boolean);
    }

    function cardMatches(card) {
      if (activeType && cardTags(card).indexOf(activeType) === -1) return false;
      if (activePlace) {
        var region = (card.getAttribute('data-region') || '').toLowerCase();
        var isCalifornia = region === 'california';
        if (activePlace === 'california' && !isCalifornia) return false;
        if (activePlace === 'not-california' && isCalifornia) return false;
      }
      if (activeArtist) {
        var artist = (card.getAttribute('data-artist') || 'garrett').toLowerCase();
        if (artist !== activeArtist) return false;
      }
      return true;
    }

    function anyFilterActive() {
      return !!(activeType || activePlace || activeArtist);
    }

    function syncTagButtons() {
      tagBtns.forEach(function (btn) {
        var group = btn.getAttribute('data-filter') || '';
        var value = btn.getAttribute('data-value') || '';
        var on =
          (group === 'type' && value === activeType) ||
          (group === 'place' && value === activePlace) ||
          (group === 'artist' && value === activeArtist);
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = cardMatches(card);
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (empty) {
        empty.hidden = visible > 0 || !anyFilterActive();
      }
      scheduleGridLayout();
      try {
        if (window.URLSearchParams && window.history && history.replaceState) {
          var p = new URLSearchParams();
          if (activeType) p.set('type', activeType);
          if (activePlace) p.set('place', activePlace);
          if (activeArtist) p.set('artist', activeArtist);
          var qs = p.toString();
          history.replaceState(null, '', qs ? '?' + qs : window.location.pathname);
        }
      } catch (err) {}
    }

    function setOpen(open) {
      if (!toggle || !panel) return;
      filter.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    function clearAndClose() {
      activeType = '';
      activePlace = '';
      activeArtist = '';
      syncTagButtons();
      applyFilters();
      setOpen(false);
    }

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = filter.classList.contains('is-open');
        if (open) clearAndClose();
        else setOpen(true);
      });
    }

    tagBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-filter') || '';
        var value = btn.getAttribute('data-value') || '';
        if (group === 'type') {
          activeType = activeType === value ? '' : value;
        } else if (group === 'place') {
          activePlace = activePlace === value ? '' : value;
        } else if (group === 'artist') {
          activeArtist = activeArtist === value ? '' : value;
        }
        syncTagButtons();
        applyFilters();
      });
    });

    // Read URL search params on init and apply matching filters
    if (window.URLSearchParams) {
      var params = new URLSearchParams(window.location.search || '');
      var typeParam = (params.get('type') || '').toLowerCase().replace(/\+/g, ' ').trim();
      if (typeParam === 'monochrome' || typeParam === 'black and white') {
        activeType = 'black and white';
      } else if (typeParam === 'color') {
        activeType = 'color';
      }
      var placeParam = (params.get('place') || '').toLowerCase().trim();
      if (placeParam === 'california') {
        activePlace = 'california';
      } else if (placeParam === 'not-california') {
        activePlace = 'not-california';
      }
      var artistParam = (params.get('artist') || '').toLowerCase().trim();
      if (artistParam === 'garrett' || artistParam.indexOf('garrett') !== -1) {
        activeArtist = 'garrett';
      } else if (artistParam === 'austin' || artistParam.indexOf('austin') !== -1) {
        activeArtist = 'austin';
      }
      if (anyFilterActive()) {
        syncTagButtons();
        applyFilters();
        setOpen(true);
      }
    }
  }

  /* ---- Lightbox --------------------------------------------------------- */
  // Delegated on document so it also works for cards re-rendered by the
  // Shopify theme editor (which injects new DOM after DOMContentLoaded).
  // The lightbox lives in theme.liquid (outside sections) so position:fixed
  // covers the full viewport — not trapped inside a transformed section shell.
  function initLightbox() {
    var lightbox = document.querySelector('.lightbox');
    if (!lightbox) return;

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var currentIndex = -1;
    var fadeTimer = null;
    var fadePhase = null;
    var queuedCard = null;
    var closeBtn = lightbox.querySelector('.lightbox__close');
    var prevBtn = lightbox.querySelector('.lightbox__nav--prev');
    var nextBtn = lightbox.querySelector('.lightbox__nav--next');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getVisibleCards() {
      return Array.prototype.slice
        .call(document.querySelectorAll('.card:not(.is-hidden)'))
        .sort(function (a, b) {
          return (
            parseInt(a.getAttribute('data-order') || '0', 10) -
            parseInt(b.getAttribute('data-order') || '0', 10)
          );
        });
    }

    function clearFade(img, caption) {
      if (fadeTimer) {
        clearTimeout(fadeTimer);
        fadeTimer = null;
      }
      fadePhase = null;
      queuedCard = null;
      if (img) {
        img.classList.remove('is-fade-out', 'is-fade-in');
      }
      if (caption) {
        caption.classList.remove('is-fading');
      }
    }

    function applyCardContent(card) {
      var img = lightbox.querySelector('.lightbox__img');
      var title = lightbox.querySelector('.lightbox__title');
      var location = lightbox.querySelector('.lightbox__location');
      var buy = lightbox.querySelector('.lightbox__buy');
      var cardImg = card.querySelector('.card__img--art, .card__img');
      var preview =
        (cardImg && cardImg.currentSrc) ||
        card.getAttribute('data-preview') ||
        (cardImg && cardImg.src) ||
        '';
      var hiRes = card.getAttribute('data-image') || preview;

      title.textContent = card.getAttribute('data-title') || '';
      location.textContent = card.getAttribute('data-location') || '';
      buy.setAttribute('href', card.getAttribute('data-url') || '#');
      img.alt = card.getAttribute('data-title') || '';
      img.src = preview;

      if (hiRes && hiRes !== preview) {
        var loader = new Image();
        loader.onload = function () {
          if (lightbox.classList.contains('is-open')) img.src = hiRes;
        };
        loader.src = hiRes;
      }
    }

    function runFadeIn(img, caption) {
      fadePhase = 'in';
      img.classList.remove('is-fade-out');
      void img.offsetWidth;
      img.classList.add('is-fade-in');
      fadeTimer = setTimeout(function () {
        img.classList.remove('is-fade-in');
        if (caption) caption.classList.remove('is-fading');
        fadePhase = null;
        fadeTimer = null;
        if (queuedCard) {
          var next = queuedCard;
          queuedCard = null;
          startFade(next);
        }
      }, 110);
    }

    function startFade(card) {
      var img = lightbox.querySelector('.lightbox__img');
      var caption = lightbox.querySelector('.lightbox__caption');
      if (!img) {
        applyCardContent(card);
        return;
      }

      if (fadeTimer) {
        clearTimeout(fadeTimer);
        fadeTimer = null;
      }

      fadePhase = 'out';
      img.classList.remove('is-fade-in');
      img.classList.add('is-fade-out');
      if (caption) caption.classList.add('is-fading');

      fadeTimer = setTimeout(function () {
        var target = queuedCard || card;
        queuedCard = null;
        applyCardContent(target);
        runFadeIn(img, caption);
      }, 90);
    }

    function showCard(card, direction) {
      if (!card) return;
      var img = lightbox.querySelector('.lightbox__img');
      var caption = lightbox.querySelector('.lightbox__caption');

      if (!direction || reducedMotion.matches) {
        clearFade(img, caption);
        applyCardContent(card);
        return;
      }

      if (fadePhase === 'out') {
        queuedCard = card;
        return;
      }

      if (fadePhase === 'in') {
        if (fadeTimer) {
          clearTimeout(fadeTimer);
          fadeTimer = null;
        }
        if (img) img.classList.remove('is-fade-in');
      }

      startFade(card);
    }

    function open(card) {
      if (!card) return;
      var cards = getVisibleCards();
      currentIndex = cards.indexOf(card);
      if (currentIndex === -1) currentIndex = 0;

      showCard(cards[currentIndex] || card);
      lightbox.removeAttribute('hidden');
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.classList.remove('is-open');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
      });
    }

    function close() {
      lightbox.classList.remove('is-open');

      var closed = false;
      function finishClose() {
        if (closed) return;
        closed = true;
        lightbox.removeEventListener('transitionend', onEnd);
        lightbox.setAttribute('hidden', '');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        currentIndex = -1;
        clearFade(
          lightbox.querySelector('.lightbox__img'),
          lightbox.querySelector('.lightbox__caption')
        );
      }

      function onEnd(e) {
        if (e.target !== lightbox) return;
        finishClose();
      }

      lightbox.addEventListener('transitionend', onEnd);
      setTimeout(finishClose, 450);
    }

    function step(delta) {
      var cards = getVisibleCards();
      if (!cards.length) return;
      if (currentIndex === -1) currentIndex = 0;
      currentIndex = (currentIndex + delta + cards.length) % cards.length;
      showCard(cards[currentIndex], delta);
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.card__btn-view');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        open(btn.closest('.card'));
        return;
      }
      if (e.target === lightbox) {
        close();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        close();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        step(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        step(1);
      });
    }

    var frame = lightbox.querySelector('.lightbox__frame');
    var img = lightbox.querySelector('.lightbox__img');
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    var touchDidSwipe = false;

    function isMobileLightbox() {
      return window.matchMedia('(max-width: 639px)').matches;
    }

    frame.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    if (img) {
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        if (touchDidSwipe) {
          touchDidSwipe = false;
          return;
        }
        var rect = img.getBoundingClientRect();
        if (!rect.width) return;
        var x = e.clientX - rect.left;
        step(x < rect.width / 2 ? -1 : 1);
      });
    }

    frame.addEventListener(
      'touchstart',
      function (e) {
        if (!lightbox.classList.contains('is-open') || !isMobileLightbox()) return;
        if (!e.changedTouches || !e.changedTouches.length) return;
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        touchActive = true;
        touchDidSwipe = false;
      },
      { passive: true }
    );

    frame.addEventListener(
      'touchend',
      function (e) {
        if (!touchActive || !lightbox.classList.contains('is-open') || !isMobileLightbox()) {
          return;
        }
        touchActive = false;
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
        touchDidSwipe = true;
        step(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        close();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });
  }

  /* ---- Quantity steppers ------------------------------------------------ */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('.qty').forEach(function (qty) {
      var input = qty.querySelector('.qty__input');
      var minus = qty.querySelector('[data-qty="minus"]');
      var plus = qty.querySelector('[data-qty="plus"]');
      var min = parseInt(input.getAttribute('min') || '1', 10);

      function set(v) {
        if (isNaN(v) || v < min) v = min;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < min) input.value = min;
      });
    });
  }

  /* ---- Product form: options, variant, price, add to cart -------------- */
  function initProduct() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var dataEl = document.getElementById('product-variants');
    var raw = dataEl ? JSON.parse(dataEl.textContent) : [];
    var splitMode =
      form.getAttribute('data-split-skus') === 'true' ||
      (raw && !Array.isArray(raw) && raw.mode === 'split');
    var framedVariants = Array.isArray(raw)
      ? raw
      : raw && Array.isArray(raw.framed)
        ? raw.framed
        : [];
    var metalVariants = raw && Array.isArray(raw.metal) ? raw.metal.slice() : [];
    var metalHandle =
      (raw && raw.metalHandle) || form.getAttribute('data-metal-handle') || '';
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var qtyInput = form.querySelector('.qty__input');
    var paymentTermsId = document.querySelector('[data-payment-terms-variant]');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickyBtn = stickyBar ? stickyBar.querySelector('[data-sticky-atc-btn]') : null;
    var addRow = form.querySelector('[data-product-add-row]');
    var shopCheckoutBtn = form.querySelector('[data-shop-checkout]');
    var lastMaterialKey = null;
    var lastVariant = null;
    var lastVariantPriceCents = 0;

    function currentQty() {
      if (!qtyInput) return 1;
      var q = parseInt(qtyInput.value, 10);
      if (isNaN(q) || q < 1) return 1;
      return q;
    }

    var priceRoots = Array.prototype.slice.call(
      document.querySelectorAll('[data-product-price]')
    );
    var NEWSLETTER_DISCOUNT_CENTS = 1500;

    function effectiveLineCents(unitPriceCents) {
      var line = (unitPriceCents || 0) * currentQty();
      if (!document.documentElement.classList.contains('newsletter-subscribed')) {
        return line;
      }
      return Math.max(line - Math.min(NEWSLETTER_DISCOUNT_CENTS, Math.max(line, 0)), 0);
    }

    function formatAddLabel(unitPriceCents) {
      var base = (addBtn && addBtn.getAttribute('data-label')) || 'Add to Cart';
      return base + ' ' + money(effectiveLineCents(unitPriceCents));
    }

    function updateProductPrice(unitPriceCents, available) {
      var line = (unitPriceCents || 0) * currentQty();
      var off = Math.min(NEWSLETTER_DISCOUNT_CENTS, Math.max(line, 0));
      var finalCents = Math.max(line - off, 0);
      priceRoots.forEach(function (priceRoot) {
        var simple = priceRoot.querySelector('[data-price-value]');
        var original = priceRoot.querySelector('[data-price-original]');
        var saving = priceRoot.querySelector('[data-price-saving]');
        var finalEl = priceRoot.querySelector('[data-price-final]');
        if (simple) simple.textContent = money(line);
        if (original) original.textContent = money(line);
        if (saving) saving.textContent = '−' + money(off);
        if (finalEl) finalEl.textContent = money(finalCents);
        priceRoot.hidden = available === false;
      });
    }

    function setAddBtnLabel(available, unitPriceCents) {
      if (typeof unitPriceCents === 'number') {
        lastVariantPriceCents = unitPriceCents;
      }
      var cents =
        typeof unitPriceCents === 'number' ? unitPriceCents : lastVariantPriceCents;
      var label = available ? formatAddLabel(cents) : 'Sold Out';
      if (addBtn) {
        addBtn.textContent = label;
        addBtn.setAttribute('data-current-label', label);
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = label;
        stickyBtn.setAttribute('data-current-label', label);
      }
      if (shopCheckoutBtn) shopCheckoutBtn.disabled = !available;
      updateProductPrice(cents, available);
    }

    function setStickyVisible(visible) {
      if (!stickyBar) return;
      if (visible) {
        stickyBar.hidden = false;
        document.documentElement.classList.add('has-sticky-atc');
      } else {
        stickyBar.hidden = true;
        document.documentElement.classList.remove('has-sticky-atc');
      }
      // Floating chips re-measure so they never sit on top of the bar.
      document.dispatchEvent(new CustomEvent('gs:sticky-atc'));
    }

    function initStickyAtc() {
      if (!stickyBar || !addRow || !window.IntersectionObserver) return;
      if (window.matchMedia && !window.matchMedia('(max-width: 989px)').matches) {
        setStickyVisible(false);
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          setStickyVisible(!entry.isIntersecting);
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
      );
      observer.observe(addRow);
      if (window.matchMedia) {
        window.matchMedia('(max-width: 989px)').addEventListener('change', function (e) {
          if (!e.matches) setStickyVisible(false);
        });
      }
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (addBtn && !addBtn.disabled) {
          form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
        }
      });
    }
    initStickyAtc();

    var groups = Array.prototype.slice.call(
      form.querySelectorAll('.option[data-option-name]')
    );
    var selected = {};

    groups.forEach(function (group) {
      var pos = group.getAttribute('data-position');
      var activeBtn =
        group.querySelector('.option__choice.is-active') ||
        group.querySelector('.option__choice');
      if (activeBtn) selected[pos] = activeBtn.getAttribute('data-value');
    });

    // Default to 24×36 / Framed. Frame color follows the photograph:
    // black for black-and-white, natural oak for color.
    var wantMetal = /[?&]material=metal(?:&|$)/i.test(
      window.location.search || ''
    );
    var defaultFrame = form.getAttribute('data-default-frame') || 'Natural Oak';
    if (!/[?&]variant=/.test(window.location.search || '')) {
      var preferred = [
        { match: /size/i, values: ['24" × 36"', '24" x 36"', '36" × 24"', '36" x 24"'] },
        {
          match: /material/i,
          values: wantMetal ? ['Metal'] : ['Framed'],
        },
        { match: /frame/i, values: [defaultFrame] },
      ];
      groups.forEach(function (group) {
        var name = group.getAttribute('data-option-name') || '';
        var rule = preferred.find(function (p) {
          return p.match.test(name);
        });
        if (!rule) return;
        var pos = group.getAttribute('data-position');
        var buttons = Array.prototype.slice.call(
          group.querySelectorAll('.option__choice')
        );
        var hit = buttons.find(function (btn) {
          var val = btn.getAttribute('data-value') || '';
          return rule.values.some(function (want) {
            return val === want || val.toLowerCase() === want.toLowerCase();
          });
        });
        if (hit) selected[pos] = hit.getAttribute('data-value');
      });
    }

    function isFrameGroup(group) {
      return (
        (group.getAttribute('data-option-name') || '')
          .toLowerCase()
          .indexOf('frame') !== -1
      );
    }
    function isSyntheticMaterial(group) {
      return group.hasAttribute('data-synthetic-material');
    }
    function isBlankFrameValue(val) {
      var v = (val || '').toLowerCase();
      return v === 'none' || v === 'n/a' || v === '';
    }
    function materialGroup() {
      return groups.filter(function (g) {
        return (
          (g.getAttribute('data-option-name') || '')
            .toLowerCase()
            .indexOf('material') !== -1
        );
      })[0];
    }
    function sizeGroup() {
      return groups.filter(function (g) {
        return (
          (g.getAttribute('data-option-name') || '')
            .toLowerCase()
            .indexOf('size') !== -1
        );
      })[0];
    }
    function isMetalSelected() {
      var matG = materialGroup();
      if (!matG) return false;
      var pos = matG.getAttribute('data-position');
      return (selected[pos] || '').toLowerCase().indexOf('metal') !== -1;
    }

    function syncMaterialVisuals(force) {
      var key = isMetalSelected() ? 'metal' : 'framed';
      if (!force && key === lastMaterialKey) return;
      var prev = lastMaterialKey;
      lastMaterialKey = key;
      // Keep the room hero on the initial Framed load; only swap on Metal
      // or when the shopper changes Material.
      if (!force && prev === null && key === 'framed') return;
      document.dispatchEvent(
        new CustomEvent('gs:material-change', { detail: { material: key } })
      );
    }

    // Lumaprints framed profile: 0.875″ face on all sizes.
    // 1.5″ mat (≤12×18); 2.5″ mat (16×24+). Listed size is the photograph.
    // The frame overlaps the mat, so each finished side is
    // photograph + mat + frame face, then 0.75″ less.
    function framedExtras(w, h) {
      var short = Math.min(w, h);
      var long = Math.max(w, h);
      if (short <= 12 && long <= 18) {
        return { mat: 1.5, frame: 0.875 };
      }
      return { mat: 2.5, frame: 0.875 };
    }
    function framedOverall(w, h) {
      var extras = framedExtras(w, h);
      var add = 2 * (extras.mat + extras.frame) - 0.75;
      return { w: w + add, h: h + add };
    }
    function parseSizeLabel(label) {
      var m = String(label || '').match(
        /(\d+(?:\.\d+)?)\s*["″]?\s*[×x]\s*(\d+(?:\.\d+)?)/
      );
      if (!m) return null;
      return { a: parseFloat(m[1]), b: parseFloat(m[2]) };
    }
    function printOrientation() {
      var o = (form.getAttribute('data-print-orientation') || '').toLowerCase();
      return o === 'portrait' ? 'portrait' : 'landscape';
    }
    /** Photograph width × height for the selected size (orientation-aware). */
    function selectedPrintDims() {
      var sizeG = sizeGroup();
      if (!sizeG) return null;
      var active =
        sizeG.querySelector('.option__choice.is-active') ||
        sizeG.querySelector('.option__choice');
      if (active) {
        var dw = parseFloat(active.getAttribute('data-print-w'));
        var dh = parseFloat(active.getAttribute('data-print-h'));
        if (dw > 0 && dh > 0) return { w: dw, h: dh };
      }
      var sizePos = sizeG.getAttribute('data-position');
      var parsed = parseSizeLabel(selected[sizePos]);
      if (!parsed) return null;
      var short = Math.min(parsed.a, parsed.b);
      var long = Math.max(parsed.a, parsed.b);
      if (printOrientation() === 'portrait') {
        return { w: short, h: long };
      }
      return { w: long, h: short };
    }
    function formatInches(n) {
      if (Number.isInteger(n)) return String(n);
      return String(Math.round(n * 1000) / 1000);
    }
    function updateFrameSizeNote() {
      var note = form.querySelector('[data-frame-size-note]');
      if (!note) return;
      var matG = materialGroup();
      var sizeG = sizeGroup();
      if (!sizeG) {
        note.hidden = true;
        note.textContent = '';
        return;
      }
      if (matG && isMetalSelected()) {
        note.hidden = true;
        note.textContent = '';
        return;
      }
      if (matG) {
        var matPos = matG.getAttribute('data-position');
        var matVal = (selected[matPos] || '').toLowerCase();
        if (matVal.indexOf('fram') === -1) {
          note.hidden = true;
          note.textContent = '';
          return;
        }
      }
      var dims = selectedPrintDims();
      if (!dims) {
        note.hidden = true;
        note.textContent = '';
        return;
      }
      var overall = framedOverall(dims.w, dims.h);
      note.textContent =
        'Overall ' +
        formatInches(overall.w) +
        ' x ' +
        formatInches(overall.h) +
        ' in (with mat and frame)';
      note.hidden = false;
    }

    function hiddenPositions() {
      var hidden = {};
      var matGroup = materialGroup();
      if (matGroup && isMetalSelected()) {
        groups.forEach(function (g) {
          if (isFrameGroup(g)) {
            var p = g.getAttribute('data-position');
            hidden[p] = true;
            g.classList.add('is-hidden');
          }
        });
        return hidden;
      }
      groups.forEach(function (g) {
        if (isFrameGroup(g)) g.classList.remove('is-hidden');
      });
      return hidden;
    }

    function optionIndexForGroup(group, variant) {
      var name = (group.getAttribute('data-option-name') || '').toLowerCase();
      if (variant.selectedOptions && variant.selectedOptions.length) {
        for (var i = 0; i < variant.selectedOptions.length; i++) {
          var soName = (variant.selectedOptions[i].name || '').toLowerCase();
          if (name.indexOf('size') !== -1 && soName.indexOf('size') !== -1) {
            return i;
          }
          if (name.indexOf('frame') !== -1 && soName.indexOf('frame') !== -1) {
            return i;
          }
          if (
            name.indexOf('material') !== -1 &&
            soName.indexOf('material') !== -1
          ) {
            return i;
          }
        }
      }
      var pos = parseInt(group.getAttribute('data-position'), 10);
      if (!isNaN(pos) && pos >= 1) return pos - 1;
      return -1;
    }

    function findVariant(hidden) {
      var list =
        splitMode && isMetalSelected() ? metalVariants : framedVariants;
      return list.find(function (v) {
        return groups.every(function (g) {
          if (isSyntheticMaterial(g)) return true;
          var pos = g.getAttribute('data-position');
          if (hidden[pos]) return true;
          var idx = optionIndexForGroup(g, v);
          if (idx < 0) return true;
          return v.options[idx] === selected[pos];
        });
      });
    }

    function update() {
      var hidden = hiddenPositions();

      groups.forEach(function (g) {
        if (!isFrameGroup(g)) return;
        var pos = g.getAttribute('data-position');
        if (hidden[pos]) return;
        if (!isBlankFrameValue(selected[pos])) return;
        var first = Array.prototype.find.call(
          g.querySelectorAll('.option__choice'),
          function (btn) {
            return !isBlankFrameValue(btn.getAttribute('data-value'));
          }
        );
        if (first) selected[pos] = first.getAttribute('data-value');
      });

      var variant = findVariant(hidden);

      // Reflect the resolved frame value back into selection state (legacy).
      if (variant && !splitMode) {
        groups.forEach(function (g) {
          var pos = g.getAttribute('data-position');
          if (!hidden[pos]) return;
          var idx = optionIndexForGroup(g, variant);
          if (idx >= 0) selected[pos] = variant.options[idx];
        });
      }

      groups.forEach(function (g) {
        var pos = g.getAttribute('data-position');
        g.querySelectorAll('.option__choice').forEach(function (btn) {
          btn.classList.toggle(
            'is-active',
            btn.getAttribute('data-value') === selected[pos]
          );
        });
        var swatchName = g.querySelector('[data-swatch-name]');
        if (swatchName && selected[pos]) {
          swatchName.textContent = selected[pos];
        }
      });

      if (variant) {
        lastVariant = variant;
        idInput.value = variant.id;
        if (paymentTermsId) {
          paymentTermsId.value = variant.id;
          paymentTermsId.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          setAddBtnLabel(variant.available, variant.price);
        } else {
          setAddBtnLabel(variant.available, variant.price);
        }
      } else {
        lastVariant = null;
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        if (stickyBtn) {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'Unavailable';
        }
        priceRoots.forEach(function (priceRoot) {
          priceRoot.hidden = true;
        });
      }

      updateFrameSizeNote();
      syncMaterialVisuals(false);
    }

    groups.forEach(function (group) {
      group.querySelectorAll('.option__choice').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = group.getAttribute('data-position');
          selected[pos] = btn.getAttribute('data-value');
          update();
          document.dispatchEvent(new CustomEvent('gs:print-preview'));
        });
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        if (lastVariant) {
          setAddBtnLabel(lastVariant.available, lastVariant.price);
        }
      });
      qtyInput.addEventListener('input', function () {
        if (lastVariant) {
          setAddBtnLabel(lastVariant.available, lastVariant.price);
        }
      });
    }

    function setAtcLoading(loading) {
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.classList.toggle('is-loading', loading);
        if (loading) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        } else {
          btn.removeAttribute('aria-busy');
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qtyInput = form.querySelector('.qty__input');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!idInput.value) return;
      if (addBtn && addBtn.classList.contains('is-loading')) return;
      setAtcLoading(true);
      var started = Date.now();
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: quantity }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Keep spinner visible briefly so the drawer slide feels intentional.
          var wait = Math.max(0, 320 - (Date.now() - started));
          return new Promise(function (resolve) {
            setTimeout(resolve, wait);
          }).then(function () {
            return refreshCart(true);
          });
        })
        .then(function () {
          setAtcLoading(false);
          showAddedState(addBtn);
        })
        .catch(function () {
          setAtcLoading(false);
          if (addBtn) addBtn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
          if (lastVariant) {
            setAddBtnLabel(lastVariant.available, lastVariant.price);
          } else {
            if (addBtn) addBtn.textContent = formatAddLabel(lastVariantPriceCents);
            if (stickyBtn) stickyBtn.textContent = formatAddLabel(lastVariantPriceCents);
          }
        });
    });

    if (shopCheckoutBtn) {
      shopCheckoutBtn.addEventListener('click', function () {
        if (shopCheckoutBtn.disabled || shopCheckoutBtn.classList.contains('is-loading')) return;
        if (!idInput || !idInput.value) return;
        var quantity = currentQty();
        shopCheckoutBtn.classList.add('is-loading');
        shopCheckoutBtn.disabled = true;
        shopCheckoutBtn.setAttribute('aria-busy', 'true');
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(idInput.value, 10), quantity: quantity }]
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            window.location.href = root + (root.slice(-1) === '/' ? '' : '/') + 'checkout';
          })
          .catch(function () {
            shopCheckoutBtn.classList.remove('is-loading');
            shopCheckoutBtn.removeAttribute('aria-busy');
            shopCheckoutBtn.disabled = false;
          });
      });
    }

    function start() {
      update();
      if (wantMetal) syncMaterialVisuals(true);
      document.dispatchEvent(new CustomEvent('gs:print-preview', { detail: { show: false } }));
      // Re-render price if signup lands while on the PDP.
      document.addEventListener('gs:newsletter-subscribed', function () {
        if (lastVariant) {
          setAddBtnLabel(lastVariant.available, lastVariant.price);
        }
      });
    }

    if (splitMode && metalVariants.length === 0 && metalHandle) {
      fetch('/products/' + encodeURIComponent(metalHandle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('metal product fetch failed');
          return r.json();
        })
        .then(function (productJson) {
          if (productJson && Array.isArray(productJson.variants)) {
            metalVariants = productJson.variants;
          }
        })
        .catch(function () {})
        .then(start);
    } else {
      start();
    }
  }

  function showAddedState(addBtn) {
    if (!addBtn) return;
    clearTimeout(window.__addedBtnTimer);
    var addedLabel = addBtn.getAttribute('data-added-label') || 'Added';
    var restoreLabel = addBtn.getAttribute('data-current-label') ||
      addBtn.getAttribute('data-label') ||
      'Add to Cart';
    addBtn.classList.remove('is-loading');
    addBtn.removeAttribute('aria-busy');
    addBtn.textContent = addedLabel;
    addBtn.disabled = true;
    var sticky = document.querySelector('[data-sticky-atc-btn]');
    if (sticky) {
      sticky.classList.remove('is-loading');
      sticky.removeAttribute('aria-busy');
      sticky.textContent = addedLabel;
      sticky.disabled = true;
    }
    window.__addedBtnTimer = setTimeout(function () {
      addBtn.disabled = false;
      addBtn.textContent = restoreLabel;
      if (sticky) {
        sticky.disabled = false;
        sticky.textContent = sticky.getAttribute('data-current-label') || restoreLabel;
      }
    }, 1800);
  }

  /* ---- Product gallery (thumbs + arrows + zoom) ------------------------ */
  function initProductGallery() {
    var root = document.querySelector('[data-product-gallery]');
    var main = root ? root.querySelector('[data-product-main-img]') : null;
    var thumbs = root
      ? Array.prototype.slice.call(root.querySelectorAll('.product__thumb'))
      : [];
    var zoom = document.querySelector('[data-product-zoom]');
    var zoomImg = zoom ? zoom.querySelector('[data-zoom-img]') : null;
    var zoomFrame = zoom ? zoom.querySelector('.product-zoom__frame') : null;
    var zoomPrev = zoom ? zoom.querySelector('[data-zoom-prev]') : null;
    var zoomNext = zoom ? zoom.querySelector('[data-zoom-next]') : null;
    var zoomClose = zoom ? zoom.querySelector('[data-zoom-close]') : null;
    var preloadCache = Object.create(null);
    var zoomLoadToken = 0;
    var externalSources = null;
    var index = Math.max(
      0,
      thumbs.findIndex(function (t) {
        return t.classList.contains('is-active');
      })
    );
    if (index < 0) index = 0;

    // Pinch / double-tap zoom inside the overlay
    var viewScale = 1;
    var viewX = 0;
    var viewY = 0;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var panStartX = 0;
    var panStartY = 0;
    var panOriginX = 0;
    var panOriginY = 0;
    var lastTapAt = 0;
    var lastTapX = 0;
    var lastTapY = 0;
    var activePointers = Object.create(null);
    var pointerCount = 0;

    function preload(url) {
      if (!url || preloadCache[url]) return;
      preloadCache[url] = true;
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
    }

    function preloadAll() {
      thumbs.forEach(function (t) {
        preload(t.getAttribute('data-full'));
        preload(t.getAttribute('data-zoom'));
      });
      if (main) {
        preload(main.getAttribute('data-zoom'));
        preload(main.src);
      }
    }

    function sourceCount() {
      if (externalSources && externalSources.length) return externalSources.length;
      return thumbs.length || (main ? 1 : 0);
    }

    function urlsForIndex(i) {
      if (externalSources && externalSources.length) {
        var ext = externalSources[i] || externalSources[0];
        return { full: ext.full, hi: ext.hi || ext.full };
      }
      if (thumbs.length) {
        var thumb = thumbs[i];
        var full = thumb.getAttribute('data-full') || (main && main.src) || '';
        var hi = thumb.getAttribute('data-zoom') || full;
        return { full: full, hi: hi };
      }
      if (main) {
        return {
          full: main.src,
          hi: main.getAttribute('data-zoom') || main.src,
        };
      }
      return { full: '', hi: '' };
    }

    function applyViewTransform(animate) {
      if (!zoomImg) return;
      zoomImg.style.transition = animate ? 'transform 0.22s ease' : 'none';
      zoomImg.style.transform =
        'translate3d(' + viewX + 'px,' + viewY + 'px,0) scale(' + viewScale + ')';
      zoomImg.classList.toggle('is-zoomed', viewScale > 1.01);
    }

    function resetViewTransform() {
      viewScale = 1;
      viewX = 0;
      viewY = 0;
      if (zoomImg) {
        zoomImg.classList.remove('is-zoomed', 'is-panning');
        zoomImg.style.transition = 'none';
        zoomImg.style.transform = '';
      }
    }

    function clampPan() {
      if (!zoomImg || viewScale <= 1) {
        viewX = 0;
        viewY = 0;
        return;
      }
      var rect = zoomImg.getBoundingClientRect();
      var baseW = rect.width / viewScale;
      var baseH = rect.height / viewScale;
      var maxX = Math.max(0, (baseW * viewScale - baseW) / 2);
      var maxY = Math.max(0, (baseH * viewScale - baseH) / 2);
      if (viewX > maxX) viewX = maxX;
      if (viewX < -maxX) viewX = -maxX;
      if (viewY > maxY) viewY = maxY;
      if (viewY < -maxY) viewY = -maxY;
    }

    /** Show full (already warm from gallery) immediately; upgrade to hi-res when ready. */
    function setZoomImage(i) {
      if (!zoomImg) return;
      var count = sourceCount();
      if (!count) return;
      index = ((i % count) + count) % count;
      var urls = urlsForIndex(index);
      var token = ++zoomLoadToken;
      resetViewTransform();
      zoomImg.src = urls.full;
      if (urls.hi && urls.hi !== urls.full) {
        var hi = new Image();
        hi.onload = function () {
          if (token !== zoomLoadToken) return;
          zoomImg.src = urls.hi;
        };
        hi.src = urls.hi;
      }
      if (count > 1) {
        var next = (index + 1) % count;
        var prev = (index - 1 + count) % count;
        preload(urlsForIndex(next).full);
        preload(urlsForIndex(next).hi);
        preload(urlsForIndex(prev).full);
        preload(urlsForIndex(prev).hi);
      }
      syncZoomNav();
    }

    function syncZoomNav() {
      var many = sourceCount() > 1;
      if (zoomPrev) zoomPrev.hidden = !many;
      if (zoomNext) zoomNext.hidden = !many;
    }

    var dyn = root ? root.querySelector('[data-product-dyn]') : null;
    var dynFrame = dyn ? dyn.querySelector('[data-dyn-frame]') : null;
    var dynPrint = dyn ? dyn.querySelector('[data-dyn-print]') : null;
    var dynPhoto = dyn ? dyn.querySelector('[data-dyn-photo]') : null;
    var dynThumb = root ? root.querySelector('[data-dyn-thumb]') : null;
    var dynThumbPrint = dynThumb ? dynThumb.querySelector('[data-dyn-thumb-print]') : null;
    var dynThumbFrame = dynThumb ? dynThumb.querySelector('[data-dyn-thumb-frame]') : null;
    var zoomDyn = document.querySelector('[data-zoom-dyn-stage]');
    var zoomDynPrint = zoomDyn ? zoomDyn.querySelector('[data-zoom-dyn-print]') : null;
    var zoomDynFrame = zoomDyn ? zoomDyn.querySelector('[data-zoom-dyn-frame]') : null;
    var zoomDynPhoto = zoomDyn ? zoomDyn.querySelector('[data-zoom-dyn-photo]') : null;
    var zoomDynPanel = document.querySelector('[data-zoom-dyn]');
    var heroDyn = document.querySelector('[data-hero-dyn-stage]');
    var heroDynPrint = heroDyn ? heroDyn.querySelector('[data-hero-dyn-print]') : null;
    var heroDynFrame = heroDyn ? heroDyn.querySelector('[data-hero-dyn-frame]') : null;
    var heroDynPhoto = heroDyn ? heroDyn.querySelector('[data-hero-dyn-photo]') : null;
    var roomDyn = document.querySelector('[data-room-dyn]');
    var roomDynPrint = roomDyn ? roomDyn.querySelector('[data-room-dyn-print]') : null;
    var roomDynFrame = roomDyn ? roomDyn.querySelector('[data-room-dyn-frame]') : null;
    var roomDynPhoto = roomDyn ? roomDyn.querySelector('[data-room-dyn-photo]') : null;
    var dynFrames = null;
    if (dyn) {
      var dynJson = dyn.querySelector('[data-dyn-frames]');
      if (dynJson) {
        try {
          dynFrames = JSON.parse(dynJson.textContent);
        } catch (err) {
          dynFrames = null;
        }
      }
    }
    var photoPx = {
      landscape: {
        large: [1525, 1017],
        medium: [1021, 680],
        small: [756, 503],
      },
      portrait: {
        large: [1017, 1525],
        medium: [680, 1021],
        small: [503, 756],
      },
    };

    function readPrintPreview() {
      var form = document.querySelector('[data-product-form]');
      var orient =
        (form && form.getAttribute('data-print-orientation')) || 'landscape';
      if (orient !== 'portrait') orient = 'landscape';
      var size = 'medium';
      var pw = 0;
      var ph = 0;
      var sizeBtn = form
        ? form.querySelector('.option--sizes .option__choice.is-active')
        : null;
      if (sizeBtn) {
        pw = parseFloat(sizeBtn.getAttribute('data-print-w')) || 0;
        ph = parseFloat(sizeBtn.getAttribute('data-print-h')) || 0;
        var longEdge = Math.max(pw, ph);
        if (longEdge && longEdge <= 18) size = 'small';
        else if (longEdge && longEdge <= 24) size = 'medium';
        else if (longEdge) size = 'large';
      }
      var metalBtn = form
        ? form.querySelector('[data-synthetic-material] .option__choice.is-active, .option[data-option-name="Material"] .option__choice.is-active')
        : null;
      var metal = false;
      if (metalBtn) {
        metal = (metalBtn.getAttribute('data-value') || '').toLowerCase().indexOf('metal') !== -1;
      }
      var color = 'oak';
      var swatch = form
        ? form.querySelector('.option--swatches .option__choice.is-active')
        : null;
      var frameLabel = '';
      if (swatch) {
        var key = (swatch.getAttribute('data-swatch') || '').toLowerCase();
        if (key === 'black' || key === 'white' || key === 'oak') color = key;
        frameLabel = swatch.getAttribute('data-value') || '';
      }
      return {
        orient: orient,
        size: size,
        metal: metal,
        color: color,
        pw: pw,
        ph: ph,
        frameLabel: frameLabel,
      };
    }

    function formatInches(n) {
      if (!n) return '';
      var rounded = Math.round(n * 100) / 100;
      if (Math.abs(rounded - Math.round(rounded)) < 0.001) return String(Math.round(rounded));
      return String(rounded);
    }

    function syncDynCaption(opts) {
      var nodes = document.querySelectorAll('[data-dyn-caption]');
      if (!nodes.length) return;
      var names = { small: 'Small', medium: 'Medium', large: 'Large' };
      var sizeLine = names[opts.size] || 'Medium';
      if (opts.pw && opts.ph) {
        sizeLine += ' ' + formatInches(opts.pw) + ' x ' + formatInches(opts.ph) + ' in';
      }
      var detailLine = 'Metal';
      if (!opts.metal && opts.frameLabel) {
        detailLine = /frame/i.test(opts.frameLabel) ? opts.frameLabel : opts.frameLabel + ' Frame';
      }
      nodes.forEach(function (node) {
        var sizeEl = node.querySelector('[data-dyn-cap-size]');
        var typeEl = node.querySelector('[data-dyn-cap-type]');
        var frameEl = node.querySelector('[data-dyn-cap-frame]');
        if (sizeEl) sizeEl.textContent = sizeLine;
        if (typeEl) typeEl.textContent = detailLine;
        if (frameEl) frameEl.setAttribute('hidden', '');
      });
    }

    function frameSrc(opts) {
      var ratio = opts.orient === 'portrait' ? '2x3' : '3x2';
      if (!dynFrames || !dynFrames[ratio] || !dynFrames[ratio][opts.size]) return '';
      return dynFrames[ratio][opts.size][opts.color] || '';
    }

    function preloadDynFrames() {
      if (!dynFrames) return;
      var opts = readPrintPreview();
      var ratio = opts.orient === 'portrait' ? '2x3' : '3x2';
      var sizes = dynFrames[ratio];
      if (!sizes) return;
      Object.keys(sizes).forEach(function (size) {
        Object.keys(sizes[size]).forEach(function (color) {
          var url = sizes[size][color];
          if (!url) return;
          var img = new Image();
          img.decoding = 'async';
          img.src = url;
          if (img.decode) img.decode().catch(function () {});
        });
      });
    }

    var previewToken = 0;

    function applyPrintPreview() {
      if (!dyn || !dynPrint) return;
      var token = ++previewToken;
      var opts = readPrintPreview();
      var pair = (photoPx[opts.orient] || photoPx.landscape)[opts.size] || photoPx.landscape.medium;
      var src = frameSrc(opts);
      var frames = [dynFrame, dynThumbFrame, zoomDynFrame, heroDynFrame, roomDynFrame];
      var waitForFrame = src && !opts.metal && frames.some(function (img) {
        return img && img.getAttribute('src') !== src;
      });

      function commit() {
        if (token !== previewToken) return;
      dynPrint.style.setProperty('--photo-w', String(pair[0]));
      dynPrint.style.setProperty('--photo-h', String(pair[1]));
      dyn.classList.toggle('is-metal', opts.metal);
      if (dynThumbPrint) {
        dynThumbPrint.style.setProperty('--photo-w', String(pair[0]));
        dynThumbPrint.style.setProperty('--photo-h', String(pair[1]));
      }
      if (dynThumb) dynThumb.classList.toggle('is-metal', opts.metal);
      if (zoomDynPrint) {
        zoomDynPrint.style.setProperty('--photo-w', String(pair[0]));
        zoomDynPrint.style.setProperty('--photo-h', String(pair[1]));
      }
      if (zoomDyn) zoomDyn.classList.toggle('is-metal', opts.metal);
      if (heroDynPrint) {
        heroDynPrint.style.setProperty('--photo-w', String(pair[0]));
        heroDynPrint.style.setProperty('--photo-h', String(pair[1]));
      }
      if (heroDyn) heroDyn.classList.toggle('is-metal', opts.metal);
      if (roomDynPrint) {
        roomDynPrint.style.setProperty('--photo-w', String(pair[0]));
        roomDynPrint.style.setProperty('--photo-h', String(pair[1]));
      }
      if (roomDyn) {
        roomDyn.style.setProperty('--photo-w', String(pair[0]));
        roomDyn.style.setProperty('--photo-h', String(pair[1]));
        roomDyn.classList.toggle('is-metal', opts.metal);
      }
      if (dynPhoto) {
        var stage = dyn.parentElement;
        var stageW = stage ? stage.getBoundingClientRect().width : 0;
        if (stageW) {
          dynPhoto.setAttribute('sizes', Math.max(1, Math.round((stageW * pair[0]) / 2200)) + 'px');
        }
      }
      if (zoomDynPhoto && zoomDyn) {
        var zoomW = zoomDyn.getBoundingClientRect().width;
        if (zoomW) {
          zoomDynPhoto.setAttribute('sizes', Math.max(1, Math.round((zoomW * pair[0]) / 2200)) + 'px');
        }
      }
      if (heroDynPhoto && heroDyn) {
        var heroW = heroDyn.getBoundingClientRect().width;
        if (heroW) {
          heroDynPhoto.setAttribute('sizes', Math.max(1, Math.round((heroW * pair[0]) / 2200)) + 'px');
        }
      }
      if (roomDynPhoto && roomDyn) {
        var roomW = roomDyn.getBoundingClientRect().width;
        if (roomW) {
          roomDynPhoto.setAttribute('sizes', Math.max(1, Math.round((roomW * pair[0]) / 2200)) + 'px');
        }
      }
        frames.forEach(function (img) {
          if (src && img && img.getAttribute('src') !== src) img.src = src;
        });
        syncDynCaption(opts);
        syncZoomControls();
        [
          dyn,
          dynThumb,
          zoomDyn,
          heroDyn,
          roomDyn
        ].forEach(function (node) {
          if (!node) return;
          node.classList.remove('is-ready');
          armProductDyn(node);
        });
      }

      if (!waitForFrame) {
        commit();
        return;
      }
      var pre = new Image();
      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        commit();
      }
      pre.onload = finish;
      pre.onerror = finish;
      pre.src = src;
      if (pre.complete) finish();
    }

    function formChoice(selector, value) {
      var form = document.querySelector('[data-product-form]');
      if (!form) return null;
      var group = form.querySelector(selector);
      if (!group) return null;
      var buttons = group.querySelectorAll('.option__choice');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].getAttribute('data-value') === value) return buttons[i];
      }
      return null;
    }

    function syncZoomControls() {
      if (!zoomDynPanel) return;
      var kinds = {
        size: '.option--sizes',
        material: '[data-synthetic-material], [data-option-name="Material"]',
        frame: '.option--swatches',
      };
      Object.keys(kinds).forEach(function (kind) {
        var active = null;
        var form = document.querySelector('[data-product-form]');
        var group = form ? form.querySelector(kinds[kind]) : null;
        if (group) active = group.querySelector('.option__choice.is-active');
        var val = active ? active.getAttribute('data-value') : '';
        zoomDynPanel.querySelectorAll('[data-zoom-set="' + kind + '"]').forEach(function (btn) {
          var on = btn.getAttribute('data-value') === val;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function showDynamic() {
      var dynThumb = thumbs.find(function (t) {
        return t.hasAttribute('data-dynamic-mockup');
      });
      if (!dynThumb) return;
      applyPrintPreview();
      show(parseInt(dynThumb.getAttribute('data-gallery-index'), 10) || 0);
    }

    function show(i) {
      if (!thumbs.length || !main) return;
      // Gallery navigation leaves hero-sourced zoom lists
      externalSources = null;
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      var isDyn = thumb.hasAttribute('data-dynamic-mockup');
      if (!isDyn) {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        var zoomUrl = thumb.getAttribute('data-zoom');
        if (zoomUrl) main.setAttribute('data-zoom', zoomUrl);
        var thumbImg = thumb.querySelector('img');
        if (thumbImg) {
          var w = thumbImg.getAttribute('width');
          var h = thumbImg.getAttribute('height');
          if (w) main.setAttribute('width', w);
          if (h) main.setAttribute('height', h);
        }
      }
      if (dyn) dyn.hidden = !isDyn;
      thumbs.forEach(function (t, n) {
        var on = n === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (zoom && zoom.classList.contains('is-open')) {
        if (isDyn) {
          zoom.classList.add('is-dyn');
          resetViewTransform();
          applyPrintPreview();
        } else {
          zoom.classList.remove('is-dyn');
          setZoomImage(index);
        }
      }
    }

    if (root && main) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          show(parseInt(thumb.getAttribute('data-gallery-index'), 10) || 0);
        });
      });

      document.addEventListener('gs:material-change', function (e) {
        if (dyn) return;
        var want = (e.detail && e.detail.material) || 'framed';
        var prefer = thumbs.find(function (t) {
          return (
            t.hasAttribute('data-prefer-material') &&
            t.getAttribute('data-material') === want
          );
        });
        if (!prefer) {
          prefer = thumbs.find(function (t) {
            var m = t.getAttribute('data-material') || '';
            return m === want || m === 'both';
          });
        }
        if (prefer) {
          show(parseInt(prefer.getAttribute('data-gallery-index'), 10) || 0);
        }
      });

      document.addEventListener('gs:print-preview', function (e) {
        if (e.detail && e.detail.show === false) {
          applyPrintPreview();
          return;
        }
        showDynamic();
      });
      applyPrintPreview();
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 150); };
      idle(preloadDynFrames);
      if (!root.hasAttribute('data-dyn-resize')) {
        root.setAttribute('data-dyn-resize', '');
        window.addEventListener('resize', applyPrintPreview);
      }

      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      if (prev) {
        prev.addEventListener('click', function (e) {
          e.stopPropagation();
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          e.stopPropagation();
          show(index + 1);
        });
      }

      preloadAll();
    }

    if (!zoom || !zoomImg) return;

    if (zoom.parentElement !== document.body) {
      document.body.appendChild(zoom);
    }

    syncZoomNav();

    function openZoom(startIndex) {
      if (typeof startIndex === 'number') index = startIndex;
      zoom.classList.remove('is-dyn');
      setZoomImage(index);
      zoom.removeAttribute('hidden');
      zoom.setAttribute('aria-hidden', 'false');
      zoom.classList.remove('is-open');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          zoom.classList.add('is-open');
        });
      });
    }

    function openDynZoom() {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      zoom.classList.add('is-dyn');
      applyPrintPreview();
      zoom.removeAttribute('hidden');
      zoom.setAttribute('aria-hidden', 'false');
      zoom.classList.remove('is-open');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          zoom.classList.add('is-open');
          applyPrintPreview();
        });
      });
    }

    function closeZoom() {
      zoom.classList.remove('is-open');
      var closed = false;
      function finish() {
        if (closed) return;
        closed = true;
        zoom.removeEventListener('transitionend', onEnd);
        zoom.classList.remove('is-dyn');
        zoom.setAttribute('hidden', '');
        zoom.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        resetViewTransform();
      }
      function onEnd(e) {
        if (e.target !== zoom) return;
        finish();
      }
      zoom.addEventListener('transitionend', onEnd);
      setTimeout(finish, 420);
    }

    function stepZoom(delta) {
      var count = sourceCount();
      if (count < 2) return;
      if (externalSources && externalSources.length) {
        setZoomImage(index + delta);
        return;
      }
      if (thumbs.length) show(index + delta);
      else setZoomImage(index + delta);
    }

    function openFromSources(sources, startIndex) {
      externalSources = sources && sources.length ? sources : null;
      openZoom(typeof startIndex === 'number' ? startIndex : 0);
    }

    if (dyn) {
      dyn.addEventListener('click', function () {
        openDynZoom();
      });
      dyn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDynZoom();
        }
      });
    }
    if (zoomDynPanel) {
      zoomDynPanel.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-zoom-set]');
        if (!btn) return;
        e.stopPropagation();
        var kind = btn.getAttribute('data-zoom-set');
        var value = btn.getAttribute('data-value');
        if (kind === 'frame') {
          var metalNow = formChoice(
            '[data-synthetic-material], [data-option-name="Material"]',
            'Metal'
          );
          if (metalNow && metalNow.classList.contains('is-active')) {
            var framedNow = formChoice(
              '[data-synthetic-material], [data-option-name="Material"]',
              'Framed'
            );
            if (!framedNow) {
              var matGroup = document.querySelector(
                '[data-product-form] [data-synthetic-material], [data-product-form] [data-option-name="Material"]'
              );
              if (matGroup) {
                var matBtns = matGroup.querySelectorAll('.option__choice');
                for (var mi = 0; mi < matBtns.length; mi++) {
                  if ((matBtns[mi].getAttribute('data-value') || '').toLowerCase().indexOf('fram') !== -1) {
                    framedNow = matBtns[mi];
                    break;
                  }
                }
              }
            }
            if (framedNow) framedNow.click();
          }
          var frameBtn = formChoice('.option--swatches', value);
          if (frameBtn) frameBtn.click();
          return;
        }
        var selector =
          kind === 'size'
            ? '.option--sizes'
            : '[data-synthetic-material], [data-option-name="Material"]';
        var choice = formChoice(selector, value);
        if (choice) choice.click();
      });
    }

    if (main) {
      main.addEventListener('click', function () {
        if (dyn && !dyn.hidden) return;
        externalSources = null;
        openZoom(index);
      });
      main.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (dyn && !dyn.hidden) {
          openDynZoom();
          return;
        }
        externalSources = null;
        openZoom(index);
      });
    }

    document.addEventListener('gs:open-product-zoom', function (e) {
      var detail = e.detail || {};
      if (detail.sources && detail.sources.length) {
        openFromSources(detail.sources, detail.index || 0);
        return;
      }
      if (detail.full) {
        openFromSources(
          [{ full: detail.full, hi: detail.hi || detail.full }],
          0
        );
      }
    });

    if (zoomClose) {
      zoomClose.addEventListener('click', function (e) {
        e.stopPropagation();
        closeZoom();
      });
    }
    if (zoomPrev) {
      zoomPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        stepZoom(-1);
      });
    }
    if (zoomNext) {
      zoomNext.addEventListener('click', function (e) {
        e.stopPropagation();
        stepZoom(1);
      });
    }
    zoom.addEventListener('click', function (e) {
      if (e.target === zoom) closeZoom();
    });
    if (zoomFrame) {
      zoomFrame.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!zoom.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeZoom();
      else if (e.key === 'ArrowLeft' && sourceCount() > 1) {
        e.preventDefault();
        stepZoom(-1);
      } else if (e.key === 'ArrowRight' && sourceCount() > 1) {
        e.preventDefault();
        stepZoom(1);
      }
    });

    // Pointer-based pinch + pan + double-tap zoom
    function pointerList() {
      return Object.keys(activePointers).map(function (id) {
        return activePointers[id];
      });
    }

    function distanceBetween(a, b) {
      var dx = a.x - b.x;
      var dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function onPointerDown(e) {
      if (!zoom.classList.contains('is-open')) return;
      if (e.target.closest && e.target.closest('[data-zoom-close], [data-zoom-prev], [data-zoom-next]')) {
        return;
      }
      activePointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      pointerCount += 1;
      try {
        zoomImg.setPointerCapture(e.pointerId);
      } catch (err) {}

      var pts = pointerList();
      if (pts.length === 2) {
        pinchStartDist = distanceBetween(pts[0], pts[1]) || 1;
        pinchStartScale = viewScale;
        zoomImg.classList.add('is-panning');
      } else if (pts.length === 1) {
        panStartX = pts[0].x;
        panStartY = pts[0].y;
        panOriginX = viewX;
        panOriginY = viewY;
        if (viewScale > 1.01) zoomImg.classList.add('is-panning');
      }
    }

    function onPointerMove(e) {
      if (!activePointers[e.pointerId]) return;
      activePointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var pts = pointerList();
      if (pts.length >= 2) {
        var dist = distanceBetween(pts[0], pts[1]) || 1;
        viewScale = Math.min(4, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
        if (viewScale <= 1.01) {
          viewScale = 1;
          viewX = 0;
          viewY = 0;
        } else {
          clampPan();
        }
        applyViewTransform(false);
        return;
      }
      if (pts.length === 1 && viewScale > 1.01) {
        viewX = panOriginX + (pts[0].x - panStartX);
        viewY = panOriginY + (pts[0].y - panStartY);
        clampPan();
        applyViewTransform(false);
      }
    }

    function onPointerUp(e) {
      if (!activePointers[e.pointerId]) return;
      var wasSingle = pointerCount === 1;
      var upX = e.clientX;
      var upY = e.clientY;
      delete activePointers[e.pointerId];
      pointerCount = Math.max(0, pointerCount - 1);
      try {
        zoomImg.releasePointerCapture(e.pointerId);
      } catch (err) {}

      if (pointerCount === 0) {
        zoomImg.classList.remove('is-panning');
        if (viewScale < 1.05) {
          viewScale = 1;
          viewX = 0;
          viewY = 0;
          applyViewTransform(true);
        } else {
          clampPan();
          applyViewTransform(true);
        }

        if (wasSingle) {
          var now = Date.now();
          var dt = now - lastTapAt;
          var dx = Math.abs(upX - lastTapX);
          var dy = Math.abs(upY - lastTapY);
          if (dt < 320 && dx < 28 && dy < 28) {
            if (viewScale > 1.2) {
              viewScale = 1;
              viewX = 0;
              viewY = 0;
            } else {
              viewScale = 2.4;
              var rect = zoomImg.getBoundingClientRect();
              var cx = rect.left + rect.width / 2;
              var cy = rect.top + rect.height / 2;
              viewX = (cx - upX) * (viewScale - 1);
              viewY = (cy - upY) * (viewScale - 1);
              clampPan();
            }
            applyViewTransform(true);
            lastTapAt = 0;
          } else {
            lastTapAt = now;
            lastTapX = upX;
            lastTapY = upY;
          }
        }
      } else if (pointerCount === 1) {
        var remaining = pointerList()[0];
        panStartX = remaining.x;
        panStartY = remaining.y;
        panOriginX = viewX;
        panOriginY = viewY;
        pinchStartScale = viewScale;
      }
    }

    zoomImg.addEventListener('pointerdown', onPointerDown);
    zoomImg.addEventListener('pointermove', onPointerMove);
    zoomImg.addEventListener('pointerup', onPointerUp);
    zoomImg.addEventListener('pointercancel', onPointerUp);
    zoomImg.addEventListener(
      'wheel',
      function (e) {
        if (!zoom.classList.contains('is-open')) return;
        e.preventDefault();
        var next = viewScale * (e.deltaY < 0 ? 1.12 : 0.9);
        viewScale = Math.min(4, Math.max(1, next));
        if (viewScale <= 1.01) {
          viewScale = 1;
          viewX = 0;
          viewY = 0;
        } else {
          clampPan();
        }
        applyViewTransform(false);
      },
      { passive: false }
    );
  }

  /* ---- Cart drawer ------------------------------------------------------ */
  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var wasHidden = drawer.hasAttribute('hidden');
    if (wasHidden) drawer.removeAttribute('hidden');
    document.documentElement.classList.add('cart-drawer-open');
    if (wasHidden) {
      // Paint the off-screen panel first so translateX(100% → 0) can animate.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
      });
    } else {
      drawer.classList.add('is-open');
    }
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
    }, 480);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCartDrawer(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var countLabel = drawer.querySelector('[data-cart-drawer-count-label]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var body = drawer.querySelector('.cart-drawer__body');
    var checkout = drawer.querySelector('[data-cart-checkout]');
    var count = cart.item_count || 0;
    var emptyMsg = drawer.getAttribute('data-i18n-empty') || 'Your cart is empty';
    var browseLabel = drawer.getAttribute('data-i18n-browse') || 'Browse Prints';
    var browseUrl = drawer.getAttribute('data-browse-url') || '/collections/prints';
    var itemOne = drawer.getAttribute('data-i18n-item-one') || '(1 item)';
    var itemsOther = drawer.getAttribute('data-i18n-items-other') || '({{ count }} items)';
    var removeLabel = drawer.getAttribute('data-i18n-remove') || 'Remove';

    if (countLabel) {
      countLabel.textContent =
        count === 1 ? itemOne : itemsOther.replace(/\{\{\s*count\s*\}\}/g, String(count));
    }
    if (subtotalEl) {
      subtotalEl.textContent = money(cart.total_price);
    }
    if (checkout) {
      if (count === 0) checkout.setAttribute('hidden', '');
      else checkout.removeAttribute('hidden');
    }
    if (!body) return;

    if (count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>' + escapeHtml(emptyMsg) + '</p>' +
          '<a href="' + escapeHtml(browseUrl) + '" class="btn btn--invert">' +
            escapeHtml(browseLabel) +
          '</a>' +
        '</div>';
      return;
    }

    var lines = cart.items || [];
    var html = '<ul class="cart-drawer__items" data-cart-drawer-items>';
    for (var i = 0; i < lines.length; i++) {
      var item = lines[i];
      var thumbHtml = item.image
        ? '<a href="' + escapeHtml(item.url) + '" class="cart-drawer__line-img" tabindex="-1" aria-hidden="true">' +
            '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="60" height="60" loading="lazy">' +
          '</a>'
        : '<a href="' + escapeHtml(item.url) + '" class="cart-drawer__line-img" tabindex="-1" aria-hidden="true">' +
            '<div class="cart-drawer__ph"></div>' +
          '</a>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__line-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      html +=
        '<li class="cart-drawer__line" data-cart-line data-line="' + (i + 1) + '" data-key="' + escapeHtml(item.key) + '">' +
          thumbHtml +
          '<div class="cart-drawer__line-main">' +
            '<div class="cart-drawer__line-top">' +
              '<a href="' + escapeHtml(item.url) + '" class="cart-drawer__line-title">' +
                escapeHtml(item.product_title || item.title) +
              '</a>' +
              '<span class="cart-drawer__line-price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            variantHtml +
            '<div class="cart-drawer__line-bottom">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-line-minus aria-label="Decrease quantity">&#8722;</button>' +
                '<span class="cart-drawer__qty-num" data-cart-line-qty>' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer__qty-btn" data-cart-line-plus aria-label="Increase quantity">&#43;</button>' +
              '</div>' +
              '<button type="button" class="cart-drawer__remove" data-cart-line-remove aria-label="' + escapeHtml(removeLabel) + '">' +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
                  '<polyline points="3 6 5 6 21 6"/>' +
                  '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>' +
                  '<path d="M10 11v6M14 11v6"/>' +
                  '<path d="M9 6V4h6v2"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }
    html += '</ul>';
    body.innerHTML = html;
  }

  function stripReviewUpload(cart) {
    var hidden = (cart.items || []).filter(function (item) {
      return item.handle === 'review-upload';
    });
    if (!hidden.length) return Promise.resolve(cart);
    var updates = {};
    hidden.forEach(function (item) {
      updates[item.key] = 0;
    });
    return fetch(routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return cart; });
  }

  function refreshCart(showDrawer) {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return stripReviewUpload(cart); })
      .then(function (cart) {
        var headerCart = document.querySelector('[data-header-cart]');
        var headerCount = document.querySelector('[data-header-cart-count]');
        if (headerCart) {
          headerCart.classList.toggle('is-visible', cart.item_count > 0);
          if (showDrawer && cart.item_count > 0) {
            headerCart.classList.remove('is-pulse');
            void headerCart.offsetWidth;
            headerCart.classList.add('is-pulse');
            clearTimeout(window.__cartPulseTimer);
            window.__cartPulseTimer = setTimeout(function () {
              headerCart.classList.remove('is-pulse');
            }, 500);
          }
        }
        var siteHeader = document.querySelector('.site-header');
        if (siteHeader) {
          siteHeader.classList.toggle('has-cart-items', cart.item_count > 0);
          fitHeaderName();
        }
        if (headerCount) headerCount.textContent = cart.item_count;
        renderCartDrawer(cart);
        if (showDrawer) openCartDrawer();
        return cart;
      });
  }

  /* ---- Floating cart lifts above footer when it enters view ------------ */
  function initFloatingCartLift() {
    var cart = document.querySelector('.floating-cart');
    var chip = document.querySelector('.newsletter-chip');
    var footer = document.querySelector('.site-footer');
    if ((!cart && !chip) || !footer) return;

    var CART_BASE = 20;
    var CHIP_BASE = 16;
    var GAP = 16;
    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var footerTop = footer.getBoundingClientRect().top;
      // Keep above sticky ATC on mobile product pages when it is visible.
      var stickyPad = 0;
      var sticky = document.querySelector('.product-sticky-atc:not([hidden])');
      if (
        sticky &&
        window.matchMedia('(max-width: 989px)').matches &&
        window.getComputedStyle(sticky).display !== 'none'
      ) {
        stickyPad = sticky.getBoundingClientRect().height + GAP;
      }
      // Lift above the footer once it enters the viewport.
      var footerLift = Math.max(0, vh - footerTop + GAP);
      if (cart) {
        cart.style.bottom = Math.max(CART_BASE + stickyPad, footerLift) + 'px';
      }
      if (chip) {
        chip.style.bottom = Math.max(CHIP_BASE + stickyPad, footerLift) + 'px';
      }
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    document.addEventListener('gs:sticky-atc', update);
    update();
  }

  function changeCartLine(key, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      return refreshCart(false);
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      // Close on backdrop or close button
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeCartDrawer();
        return;
      }
      // Qty / remove delegated on line items
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('[data-cart-line-qty]');
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      if (e.target.closest('[data-cart-line-minus]')) {
        e.preventDefault();
        changeCartLine(key, Math.max(0, currentQty - 1));
      } else if (e.target.closest('[data-cart-line-plus]')) {
        e.preventDefault();
        changeCartLine(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-line-remove]')) {
        e.preventDefault();
        changeCartLine(key, 0);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // Open drawer from floating cart button or header cart link
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-floating-cart-open]')) {
        e.preventDefault();
        openCartDrawer();
      } else if (e.target.closest('[data-header-cart]')) {
        e.preventDefault();
        openCartDrawer();
      }
    });
  }

  /* ---- Newsletter signup (chip + modal, once per browser) -------------- */
  var NEWSLETTER_STORAGE_KEY = 'gs-newsletter-popup';
  var NEWSLETTER_DELAY_MS = 12000; // kept but unused — no auto-open
  var NEWSLETTER_CODE = 'COASTAL15';
  var NEWSLETTER_SUCCESS_CLOSE_MS = 2200;

  function newsletterStorageGet() {
    try {
      return JSON.parse(localStorage.getItem(NEWSLETTER_STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function newsletterStorageSet(value) {
    try {
      localStorage.setItem(NEWSLETTER_STORAGE_KEY, JSON.stringify(value));
    } catch (e) {}
  }

  function newsletterPatchStore(patch) {
    var next = Object.assign({}, newsletterStorageGet() || {}, patch);
    newsletterStorageSet(next);
    return next;
  }

  function newsletterAlreadySubscribed() {
    var stored = newsletterStorageGet();
    return !!(stored && stored.status === 'subscribed');
  }

  // Chip skips (hides) when already dismissed or subscribed.
  function newsletterShouldSkipPopup() {
    var stored = newsletterStorageGet();
    if (!stored || !stored.status) return false;
    return stored.status === 'dismissed' || stored.status === 'subscribed';
  }

  function newsletterRoutesRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function updateCartTotalsFromCart(cart) {
    var root = document.querySelector('[data-cart-totals]');
    if (!root || !cart) return;

    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var discountRow = root.querySelector('[data-cart-discount-row]');
    var discountEl = root.querySelector('[data-cart-discount]');
    var discountLabel = root.querySelector('[data-cart-discount-label]');
    var totalRow = root.querySelector('[data-cart-total-row]');
    var totalEl = root.querySelector('[data-cart-total]');

    var discount = cart.total_discount || 0;
    // Prefer pre-discount total so Subtotal − discount = Total reads correctly
    // (items_subtotal_price is often already net of line discounts).
    var itemsSub =
      typeof cart.original_total_price === 'number'
        ? cart.original_total_price
        : typeof cart.items_subtotal_price === 'number'
          ? cart.items_subtotal_price
          : cart.total_price || 0;
    var total = cart.total_price || 0;

    if (subtotalEl) {
      subtotalEl.textContent = money(discount > 0 ? itemsSub : total);
    }

    if (discount > 0) {
      if (discountRow) discountRow.hidden = false;
      if (totalRow) totalRow.hidden = false;
      if (discountEl) discountEl.textContent = '−' + money(discount);
      if (discountLabel && cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]) {
        discountLabel.textContent =
          cart.cart_level_discount_applications[0].title || discountLabel.textContent;
      }
      if (totalEl) totalEl.textContent = money(total);
    } else {
      if (discountRow) discountRow.hidden = true;
      if (totalRow) totalRow.hidden = true;
    }
  }

  function refreshCartTotals() {
    return fetch(newsletterRoutesRoot() + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (cart) updateCartTotalsFromCart(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function applyNewsletterDiscount() {
    var root = newsletterRoutesRoot();
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: NEWSLETTER_CODE })
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return fetch(root + 'discount/' + encodeURIComponent(NEWSLETTER_CODE), {
          redirect: 'manual'
        }).then(function () {
          return refreshCartTotals();
        });
      })
      .then(function (cart) {
        if (cart && cart.token) updateCartTotalsFromCart(cart);
        else return refreshCartTotals();
        return cart;
      })
      .catch(function () {});
  }

  function markNewsletterSubscribed(email, already) {
    newsletterPatchStore({
      status: 'subscribed',
      email: (email || '').toLowerCase().trim(),
      discountApplied: true,
      alreadyOnList: !!already,
      subscribedAt: Date.now()
    });
    document.documentElement.classList.add('newsletter-subscribed');
    document.dispatchEvent(
      new CustomEvent('gs:newsletter-subscribed', { detail: { already: !!already } })
    );
  }

  function showNewsletterSuccess(root, already) {
    var formPanel = root.querySelector('[data-newsletter-signup-form-panel]');
    var successPanel = root.querySelector('[data-newsletter-signup-success]');
    var titleEl = root.querySelector('[data-newsletter-success-title]');
    var textEl = root.querySelector('[data-newsletter-success-text]');
    var popupCopy = document.getElementById('NewsletterPopupCopy');
    var copy = {};
    try {
      copy = popupCopy ? JSON.parse(popupCopy.textContent || '{}') : {};
    } catch (err) {}

    if (formPanel) formPanel.hidden = true;
    if (successPanel) successPanel.hidden = false;
    if (titleEl && already && copy.alreadyTitle) titleEl.textContent = copy.alreadyTitle;
    if (textEl && already && copy.alreadyText) textEl.textContent = copy.alreadyText;
    if (titleEl && !already && copy.successTitle) titleEl.textContent = copy.successTitle;
    if (textEl && !already && copy.successApplied) textEl.textContent = copy.successApplied;
  }

  function bindNewsletterForm(root) {
    var form = root.querySelector('form');
    var errorEl = root.querySelector('[data-newsletter-signup-error]');
    var submitBtn = root.querySelector('[data-newsletter-signup-submit]');
    if (!form || form.getAttribute('data-newsletter-bound') === 'true') return;
    form.setAttribute('data-newsletter-bound', 'true');

    form.addEventListener(
      'submit',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );

    function setSubmitting(isSubmitting) {
      if (!submitBtn) return;
      submitBtn.disabled = isSubmitting;
      if (isSubmitting) submitBtn.setAttribute('aria-busy', 'true');
      else submitBtn.removeAttribute('aria-busy');
    }

    function subscribeInBackground() {
      var action = (form.getAttribute('action') || '/contact').split('#')[0];
      return fetch(action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).catch(function () {});
    }

    function onSubmitClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      var emailInput = form.querySelector('[name="contact[email]"]');
      if (emailInput && !emailInput.checkValidity()) {
        if (errorEl) {
          errorEl.textContent =
            errorEl.getAttribute('data-error-email') ||
            'Please enter a valid email.';
          errorEl.hidden = false;
        }
        emailInput.focus();
        return;
      }

      var email = (emailInput && emailInput.value) || '';
      var stored = newsletterStorageGet() || {};
      var already =
        stored.status === 'subscribed' &&
        stored.email &&
        stored.email === email.toLowerCase().trim();

      setSubmitting(true);

      Promise.resolve(applyNewsletterDiscount())
        .catch(function () {})
        .then(function () {
          markNewsletterSubscribed(email, already);
          showNewsletterSuccess(root, already);
          if (!already) subscribeInBackground();
          window.setTimeout(function () {
            closeNewsletterModal();
          }, NEWSLETTER_SUCCESS_CLOSE_MS);
        })
        .finally(function () {
          setSubmitting(false);
        });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', onSubmitClick);
    }
  }

  function initNewsletterSignup() {
    if (
      newsletterAlreadySubscribed() ||
      document.documentElement.classList.contains('newsletter-subscribed')
    ) {
      document.documentElement.classList.add('newsletter-subscribed');
      // Keep code on the cart session for return visits (Shopify enforces
      // one-use-per-customer at checkout when the discount is configured that way).
      applyNewsletterDiscount();
    }

    document.querySelectorAll('[data-newsletter-signup]').forEach(bindNewsletterForm);
  }

  function openNewsletterModal() {
    var modal = document.querySelector('[data-newsletter-modal]');
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.classList.add('is-open');
    document.documentElement.classList.add('newsletter-modal-open');
  }

  function closeNewsletterModal() {
    var modal = document.querySelector('[data-newsletter-modal]');
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('newsletter-modal-open');
    setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '');
    }, 280);
  }

  function initNewsletterPopup() {
    var root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;

    // Sync html class from storage so CSS can hide the chip immediately
    var stored = newsletterStorageGet() || {};
    if (stored.status === 'dismissed') {
      document.documentElement.classList.add('newsletter-chip-dismissed');
    }

    root.addEventListener('click', function (e) {
      // Chip: permanent dismiss (X button)
      if (e.target.closest('[data-newsletter-chip-dismiss]')) {
        e.preventDefault();
        newsletterPatchStore({ status: 'dismissed' });
        document.documentElement.classList.add('newsletter-chip-dismissed');
        return;
      }
      // Chip body: open modal
      if (e.target.closest('[data-newsletter-chip-open]')) {
        e.preventDefault();
        openNewsletterModal();
        return;
      }
      // Modal close button or backdrop
      if (e.target.closest('[data-newsletter-modal-close]')) {
        e.preventDefault();
        closeNewsletterModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var modal = document.querySelector('[data-newsletter-modal]');
        if (modal && modal.classList.contains('is-open')) {
          closeNewsletterModal();
        }
      }
    });
  }

  /* ---- Cart page -------------------------------------------------------- */
  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    function change(line, quantity) {
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { window.location.reload(); });
    }

    page.querySelectorAll('.cart__item').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('.qty__input');
      var remove = item.querySelector('.cart__remove');
      if (input) {
        input.addEventListener('change', function () {
          change(line, parseInt(input.value, 10) || 0);
        });
      }
      if (remove) {
        remove.addEventListener('click', function () { change(line, 0); });
      }
    });
  }

  /* ---- Materials accordion: embed metal / framed visuals by heading ---- */
  function initMaterialsVisuals() {
    var root = document.querySelector('[data-materials-body]');
    if (!root || root.getAttribute('data-visuals-ready') === '1') return;

    var metalSrc = root.getAttribute('data-metal-src');
    var framedSrc = root.getAttribute('data-framed-src');
    var metalAlt = root.getAttribute('data-metal-alt') || '';
    var framedAlt = root.getAttribute('data-framed-alt') || '';
    if (!metalSrc && !framedSrc) return;

    function insertFigure(afterEl, src, alt) {
      if (!afterEl || !src) return;
      if (
        afterEl.nextElementSibling &&
        afterEl.nextElementSibling.classList.contains('product__print-visual')
      ) {
        return;
      }
      var figure = document.createElement('figure');
      figure.className = 'product__print-visual';
      var img = document.createElement('img');
      img.src = src;
      img.width = 1024;
      img.height = 1024;
      img.alt = alt;
      img.loading = 'lazy';
      figure.appendChild(img);
      afterEl.insertAdjacentElement('afterend', figure);
    }

    root.querySelectorAll('strong').forEach(function (strong) {
      var label = (strong.textContent || '').trim().toLowerCase();
      var paragraph = strong.closest('p');
      if (!paragraph) return;
      if (label === 'metal') {
        insertFigure(paragraph, metalSrc, metalAlt);
      } else if (label.indexOf('framed fine art') === 0) {
        insertFigure(paragraph, framedSrc, framedAlt);
      }
    });

    root.setAttribute('data-visuals-ready', '1');
  }

  /* ---- Product hero (room + swipe + scroll to buy) --------------------- */
  function initProductHero() {
    var hero = document.querySelector('[data-product-hero]');
    if (!hero) return;

    var allSlides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var slides = [];
    var buyBtn = hero.querySelector('.product-hero__buy[data-scroll-to-details]');
    var scrollBtns = Array.prototype.slice.call(hero.querySelectorAll('[data-scroll-to-details]'));
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var dotsRoot = hero.querySelector('[data-hero-dots]');
    var details = document.querySelector('[data-product-details]');
    var stage = hero.querySelector('[data-hero-stage]');
    var frameLayer = hero.querySelector('[data-frame-layer]');
    var frameHotspot = hero.querySelector('[data-frame-hotspot]');
    var dots = [];
    var animating = false;
    var index = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMq = window.matchMedia('(max-width: 989px)');
    var frameFocusMq = window.matchMedia('(min-width: 990px)');

    function collectSlides() {
      var hasRoom = allSlides.some(function (s) {
        return s.hasAttribute('data-room-hero');
      });
      var fallbackHero = allSlides.find(function (s) {
        return !s.hasAttribute('data-hero-art') && !s.hasAttribute('data-hero-dyn');
      });
      return allSlides.filter(function (s) {
        var isArt = s.hasAttribute('data-hero-art');
        var isDyn = s.hasAttribute('data-hero-dyn');
        if (!mobileMq.matches) return !isArt && !isDyn;
        // Mobile: room hero, raw photograph, live preview.
        if (isArt || isDyn) return true;
        if (hasRoom) return s.hasAttribute('data-room-hero');
        return s === fallbackHero;
      });
    }

    function rebuildDots() {
      dots = [];
      if (!dotsRoot) return;
      if (slides.length > 1 && mobileMq.matches) {
        dotsRoot.hidden = false;
        dotsRoot.replaceChildren();
        slides.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'product-hero__dot';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Image ' + (i + 1));
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            show(i);
          });
          dotsRoot.appendChild(btn);
          dots.push(btn);
        });
      } else {
        dotsRoot.hidden = true;
        dotsRoot.replaceChildren();
      }
    }

    function syncSlideSet(keepIndex) {
      var prevActive = slides[index];
      slides = collectSlides();
      allSlides.forEach(function (slide) {
        if (slides.indexOf(slide) === -1) {
          clearSlideClasses(slide);
          slide.classList.remove('is-active');
          slide.setAttribute('hidden', '');
        }
      });
      var nextIndex = 0;
      if (keepIndex && prevActive) {
        var found = slides.indexOf(prevActive);
        if (found >= 0) nextIndex = found;
      } else {
        var activeIdx = slides.findIndex(function (s) {
          return s.classList.contains('is-active');
        });
        if (activeIdx >= 0) nextIndex = activeIdx;
      }
      index = nextIndex;
      rebuildDots();
      if (prevBtn) prevBtn.hidden = slides.length <= 1;
      if (nextBtn) nextBtn.hidden = slides.length <= 1;
      setInstant(index);
    }

    function syncDots() {
      dots.forEach(function (dot, n) {
        var on = n === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function clearSlideClasses(slide) {
      slide.classList.remove(
        'is-enter-left',
        'is-enter-right',
        'is-exit-left',
        'is-exit-right'
      );
    }

    function layoutFrameLayer() {
      if (!stage || !frameLayer || !stage.hasAttribute('data-frame-focus')) return;
      if (!frameFocusMq.matches) {
        frameLayer.hidden = true;
        stage.classList.remove('is-frame-focus');
        return;
      }
      var active = slides[index];
      var roomActive = !!(active && active.hasAttribute('data-room-hero'));
      frameLayer.hidden = !roomActive;
      if (!roomActive) {
        stage.classList.remove('is-frame-focus');
        return;
      }
      var imgW = parseFloat(getComputedStyle(stage).getPropertyValue('--hero-img-w')) || 2752;
      var imgH = parseFloat(getComputedStyle(stage).getPropertyValue('--hero-img-h')) || 1536;
      var sw = stage.clientWidth;
      var sh = stage.clientHeight;
      if (!sw || !sh) return;
      var scale = Math.max(sw / imgW, sh / imgH);
      var rw = imgW * scale;
      var rh = imgH * scale;
      // Match .product-hero__img object-fit: cover + object-position: center top
      var ox = (sw - rw) / 2;
      var oy = 0;
      frameLayer.style.width = rw + 'px';
      frameLayer.style.height = rh + 'px';
      frameLayer.style.left = ox + 'px';
      frameLayer.style.top = oy + 'px';
    }

    function syncFrameFocus() {
      layoutFrameLayer();
    }

    function setInstant(i) {
      if (!slides.length) return;
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        clearSlideClasses(slide);
        var on = n === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('hidden');
        else slide.setAttribute('hidden', '');
      });
      syncDots();
      syncFrameFocus();
      hero.classList.toggle(
        'is-dyn-slide',
        !!(slides[index] && slides[index].hasAttribute('data-hero-dyn'))
      );
    }

    function directionFor(from, to) {
      var forward = (to - from + slides.length) % slides.length;
      var backward = (from - to + slides.length) % slides.length;
      return forward <= backward ? 1 : -1;
    }

    function show(i, dir) {
      if (!slides.length || animating) return;
      var next = ((i % slides.length) + slides.length) % slides.length;
      if (next === index) {
        syncDots();
        return;
      }

      var useSlide = mobileMq.matches && !reduced.matches && slides.length > 1;
      if (!useSlide) {
        setInstant(next);
        return;
      }

      if (dir !== 1 && dir !== -1) dir = directionFor(index, next);

      var fromSlide = slides[index];
      var toSlide = slides[next];
      animating = true;
      index = next;
      syncDots();
      syncFrameFocus();
      hero.classList.toggle(
        'is-dyn-slide',
        !!(slides[index] && slides[index].hasAttribute('data-hero-dyn'))
      );

      clearSlideClasses(fromSlide);
      clearSlideClasses(toSlide);
      toSlide.removeAttribute('hidden');
      toSlide.classList.add('is-active');
      toSlide.classList.add(dir > 0 ? 'is-enter-right' : 'is-enter-left');
      // Force layout so the enter offset applies before animating in.
      void toSlide.offsetWidth;

      requestAnimationFrame(function () {
        toSlide.classList.remove('is-enter-right', 'is-enter-left');
        fromSlide.classList.remove('is-active');
        fromSlide.classList.add(dir > 0 ? 'is-exit-left' : 'is-exit-right');
      });

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        fromSlide.removeEventListener('transitionend', onEnd);
        clearSlideClasses(fromSlide);
        clearSlideClasses(toSlide);
        fromSlide.setAttribute('hidden', '');
        fromSlide.classList.remove('is-active');
        toSlide.classList.add('is-active');
        toSlide.removeAttribute('hidden');
        animating = false;
        syncFrameFocus();
      }
      function onEnd(e) {
        if (e.target !== fromSlide || e.propertyName !== 'transform') return;
        finish();
      }
      fromSlide.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 450);
    }

    function hideBuy() {
      if (buyBtn) buyBtn.classList.add('is-hidden');
    }

    function updateBuyVisibility() {
      if (!buyBtn) return;
      if (window.scrollY > 20) hideBuy();
      else buyBtn.classList.remove('is-hidden');
    }

    function scrollToDetails() {
      if (!details) return;
      hideBuy();
      var top = details.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top,
        behavior: reduced.matches ? 'auto' : 'smooth',
      });
      details.focus({ preventScroll: true });
    }

    scrollBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToDetails();
      });
    });

    if (frameHotspot && stage) {
      frameHotspot.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        if (!frameFocusMq.matches) return;
        var active = slides[index];
        if (!active || !active.hasAttribute('data-room-hero')) return;
        stage.classList.add('is-frame-focus');
      });
      frameHotspot.addEventListener('pointerleave', function () {
        stage.classList.remove('is-frame-focus');
      });
      frameHotspot.addEventListener('focus', function () {
        if (!frameFocusMq.matches) return;
        var active = slides[index];
        if (!active || !active.hasAttribute('data-room-hero')) return;
        stage.classList.add('is-frame-focus');
      });
      frameHotspot.addEventListener('blur', function () {
        stage.classList.remove('is-frame-focus');
      });
    }

    window.addEventListener('scroll', updateBuyVisibility, { passive: true });
    updateBuyVisibility();

    if (typeof ResizeObserver !== 'undefined' && stage) {
      var ro = new ResizeObserver(function () {
        layoutFrameLayer();
      });
      ro.observe(stage);
    } else {
      window.addEventListener('resize', layoutFrameLayer);
    }
    if (frameFocusMq.addEventListener) {
      frameFocusMq.addEventListener('change', syncFrameFocus);
    } else if (frameFocusMq.addListener) {
      frameFocusMq.addListener(syncFrameFocus);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index - 1, -1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index + 1, 1);
      });
    }

    // Mobile swipe on hero stage
    if (stage) {
      var startX = 0;
      var startY = 0;
      var tracking = false;
      stage.addEventListener(
        'touchstart',
        function (e) {
          if (!mobileMq.matches || slides.length <= 1 || !e.touches.length || animating) return;
          tracking = true;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      stage.addEventListener(
        'touchend',
        function (e) {
          if (!tracking || !e.changedTouches.length) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) show(index + 1, 1);
          else show(index - 1, -1);
        },
        { passive: true }
      );
    }

    function onMobileMqChange() {
      syncSlideSet(true);
    }
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onMobileMqChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onMobileMqChange);
    }

    document.addEventListener('gs:print-preview', function (e) {
      if (!mobileMq.matches) return;
      if (e.detail && e.detail.show === false) return;
      var dynIndex = slides.findIndex(function (s) {
        return s.hasAttribute('data-hero-dyn');
      });
      if (dynIndex < 0) return;
      show(dynIndex);
    });

    syncSlideSet(false);
  }

  /* ---- Related prints carousel (PDP: 2 → 3 → 4 → 5 by width) ----------- */
  function initRelatedProducts() {
    var roots = document.querySelectorAll('[data-related-products]');
    if (!roots.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mq3 = window.matchMedia('(min-width: 1100px)');
    var mq4 = window.matchMedia('(min-width: 1450px)');
    var mq5 = window.matchMedia('(min-width: 1800px)');

    roots.forEach(function (root) {
      if (root.getAttribute('data-related-ready') === 'true') return;
      root.setAttribute('data-related-ready', 'true');

      var track = root.querySelector('[data-related-track]');
      var viewport = root.querySelector('[data-related-viewport]');
      var wrap = root.querySelector('[data-related-wrap]');
      var prev = root.querySelector('[data-related-prev]');
      var next = root.querySelector('[data-related-next]');
      if (!track || !viewport) return;

      var items = Array.prototype.slice.call(track.children);
      var count = items.length;
      if (count <= 2) return;

      var index = 0;

      function visibleCount() {
        if (mq5.matches) return 5;
        if (mq4.matches) return 4;
        if (mq3.matches) return 3;
        return 2;
      }

      function maxIndex() {
        return Math.max(0, count - visibleCount());
      }

      function gap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.gap || styles.columnGap || '0') || 0;
      }

      function stepWidth() {
        if (!items[0]) return 0;
        return items[0].getBoundingClientRect().width + gap();
      }

      function syncNav() {
        var needsNav = maxIndex() > 0;
        if (prev) prev.hidden = !needsNav;
        if (next) next.hidden = !needsNav;
        if (wrap) {
          if (needsNav) wrap.setAttribute('tabindex', '0');
          else wrap.removeAttribute('tabindex');
          wrap.classList.toggle('product-related__track-wrap--nav', needsNav);
        }
      }

      function apply(animate) {
        if (index > maxIndex()) index = maxIndex();
        if (!animate || reduceMotion) {
          track.style.transition = 'none';
        } else {
          track.style.transition = '';
        }
        track.style.transform = 'translate3d(' + -index * stepWidth() + 'px, 0, 0)';
        if (!animate || reduceMotion) {
          // Force reflow so re-enabling transition later is clean.
          void track.offsetWidth;
          track.style.transition = '';
        }
        syncNav();
      }

      function go(delta) {
        if (maxIndex() <= 0) return;
        index += delta;
        if (index < 0) index = maxIndex();
        else if (index > maxIndex()) index = 0;
        apply(true);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      if (wrap) {
        wrap.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            go(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            go(1);
          }
        });
      }

      // Swipe on the viewport — useful on phones where tiles are compact.
      var startX = 0;
      var startY = 0;
      var tracking = false;
      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches.length) return;
          tracking = true;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function (e) {
          if (!tracking || !e.changedTouches.length) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) go(1);
          else go(-1);
        },
        { passive: true }
      );

      var resizeTimer;
      function onResize() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          apply(false);
        }, 80);
      }
      window.addEventListener('resize', onResize, { passive: true });
      [mq3, mq4, mq5].forEach(function (mq) {
        if (mq.addEventListener) mq.addEventListener('change', onResize);
        else if (mq.addListener) mq.addListener(onResize);
      });

      apply(false);
    });
  }

  /* ---- About bio photo carousel ---------------------------------------- */
  function initAboutCarousel() {
    var roots = document.querySelectorAll('[data-about-carousel]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-about-ready') === '1') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-about-slide]'));
      if (slides.length < 2) return;

      root.setAttribute('data-about-ready', '1');
      var prevBtn = root.querySelector('[data-about-prev]');
      var nextBtn = root.querySelector('[data-about-next]');
      var dotsWrap = root.querySelector('[data-about-dots]');
      var index = Math.max(
        0,
        slides.findIndex(function (s) {
          return s.classList.contains('is-active');
        })
      );
      var timer = null;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'about-carousel__dot' + (i === index ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Photo ' + (i + 1));
          btn.addEventListener('click', function () {
            show(i, true);
          });
          dotsWrap.appendChild(btn);
        });
      }

      function show(i, user) {
        index = ((i % slides.length) + slides.length) % slides.length;
        slides.forEach(function (slide, n) {
          var on = n === index;
          slide.classList.toggle('is-active', on);
          if (on) slide.removeAttribute('hidden');
          else slide.setAttribute('hidden', '');
        });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, n) {
            dot.classList.toggle('is-active', n === index);
          });
        }
        if (user) restart();
      }

      function next() {
        show(index + 1, false);
      }

      function restart() {
        window.clearInterval(timer);
        timer = null;
        if (reduced.matches) return;
        timer = window.setInterval(next, 5000);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          show(index - 1, true);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          show(index + 1, true);
        });
      }

      var viewport = root.querySelector('.about-carousel__viewport') || root;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches.length) return;
          tracking = true;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function (e) {
          if (!tracking || !e.changedTouches.length) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
          show(index + (dx < 0 ? 1 : -1), true);
        },
        { passive: true }
      );

      root.addEventListener('mouseenter', function () {
        window.clearInterval(timer);
        timer = null;
      });
      root.addEventListener('mouseleave', restart);

      renderDots();
      show(index, false);
      restart();
    });
  }

  /* ---- Shared horizontal swipe → prev/next ----------------------------- */
  // Horizontal swipes step the carousel; vertical drags still scroll the page.
  // A swipe swallows the click that may follow so links/cards don't open.
  function bindSwipe(el, onPrev, onNext) {
    if (!el) return;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var suppressClick = false;
    el.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) {
          tracking = false;
          return;
        }
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );
    el.addEventListener(
      'touchend',
      function (e) {
        if (!tracking || !e.changedTouches.length) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 400);
        if (dx < 0) onNext();
        else onPrev();
      },
      { passive: true }
    );
    el.addEventListener(
      'click',
      function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  /* ---- Shared seamless loop helpers ------------------------------------ */
  function cloneCarouselSet(track, items) {
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-simple-mockup]').forEach(function (mock) {
        mock.removeAttribute('data-armed');
        mock.classList.remove('is-ready');
      });
      clone.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        img.removeAttribute('data-retry');
      });
      track.appendChild(clone);
    });
  }

  /* ---- Home favorites: 2-row grid, seamless column loop ---------------- */
  function initFavoritesCarousel() {
    var root = document.querySelector('[data-favorites-carousel]');
    if (!root || root.getAttribute('data-fav-ready') === 'true') return;
    root.setAttribute('data-fav-ready', 'true');

    var viewport = root.querySelector('[data-fav-viewport]');
    var track = root.querySelector('[data-fav-track]');
    var prevBtn = root.querySelector('[data-fav-prev]');
    var nextBtn = root.querySelector('[data-fav-next]');
    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    // 2-row grid needs an even item count so each cloned set starts on a column boundary.
    if (originals.length % 2 === 1) {
      var pad = document.createElement('li');
      pad.className = 'home-favorites__item home-favorites__item--pad';
      pad.setAttribute('aria-hidden', 'true');
      track.appendChild(pad);
      originals.push(pad);
    }

    // Triple: [set0][set1][set2] — stay in the middle set, jump by one set width.
    cloneCarouselSet(track, originals);
    cloneCarouselSet(track, originals);
    initSimpleMockups(track);

    function recoverFavoriteMockups() {
      track.querySelectorAll('[data-simple-mockup]:not(.is-ready)').forEach(function (mock) {
        mock.removeAttribute('data-armed');
        mock.querySelectorAll('img').forEach(function (img) {
          if (img.naturalWidth) return;
          img.loading = 'eager';
          var src = img.getAttribute('src');
          if (!src) return;
          img.removeAttribute('src');
          img.src = src;
        });
        armSimpleMockup(mock);
      });
    }
    window.setTimeout(recoverFavoriteMockups, 5000);
    window.addEventListener('pageshow', recoverFavoriteMockups);

    var colsPerSet = originals.length / 2;
    var offset = 0;
    var animating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ANIM_MS = 320;
    var animTimer = null;

    function setWidth() {
      return track.scrollWidth / 3;
    }

    function colWidth() {
      var w = setWidth() / colsPerSet;
      return w > 0 ? w : 0;
    }

    function apply(animate) {
      var x = offset;
      if (!animate || reduceMotion) {
        track.style.transition = 'none';
        track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
        void track.offsetWidth;
      } else {
        track.style.transition = 'transform 0.28s cubic-bezier(0.25, 0.1, 0.25, 1)';
        track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
      }
    }

    function normalize() {
      var set = setWidth();
      if (set <= 0) return false;
      var jumped = false;
      // Keep offset inside the middle copy so clones always fill either edge.
      while (offset >= set * 2 - 0.5) {
        offset -= set;
        jumped = true;
      }
      while (offset < set - 0.5) {
        offset += set;
        jumped = true;
      }
      if (jumped) apply(false);
      return jumped;
    }

    function finishAnim() {
      if (!animating) return;
      if (animTimer) {
        window.clearTimeout(animTimer);
        animTimer = null;
      }
      normalize();
      // Unlock on the next frame so a post-loop click still gets a real transition.
      requestAnimationFrame(function () {
        animating = false;
      });
    }

    function step(dir) {
      if (animating || colsPerSet < 1) return;
      var set = setWidth();
      var stepPx = colWidth();
      if (!set || !stepPx) return;

      // Pre-wrap into the middle band *before* animating so the loop step
      // never lands on a normalize-after-transition dead zone.
      if (dir > 0 && offset + stepPx >= set * 2 - 0.5) {
        offset -= set;
        apply(false);
      } else if (dir < 0 && offset - stepPx < set - 0.5) {
        offset += set;
        apply(false);
      }

      animating = true;
      offset += dir * stepPx;
      // rAF so a pre-wrap apply(false) and this apply(true) aren't same-frame.
      requestAnimationFrame(function () {
        apply(true);
        if (reduceMotion) {
          finishAnim();
          return;
        }
        animTimer = window.setTimeout(finishAnim, ANIM_MS);
      });
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      finishAnim();
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    bindSwipe(viewport, function () { step(-1); }, function () { step(1); });

    window.addEventListener(
      'resize',
      function () {
        if (animTimer) {
          window.clearTimeout(animTimer);
          animTimer = null;
        }
        animating = false;
        // Re-anchor to middle set after layout changes.
        offset = setWidth();
        apply(false);
      },
      { passive: true }
    );

    offset = setWidth();
    apply(false);
  }

  /* ---- Home reviews: seamless card loop when they overflow -------------- */
  function initReviewsCarousel() {
    var root = document.querySelector('[data-reviews-carousel]');
    if (!root || root.getAttribute('data-reviews-ready') === 'true') return;
    root.setAttribute('data-reviews-ready', 'true');

    var viewport = root.querySelector('[data-reviews-viewport]');
    var track = root.querySelector('[data-reviews-track]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var setCount = originals.length;
    var looped = false;
    var offset = 0;
    var animating = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ANIM_MS = 420;
    var animTimer = null;

    function gap() {
      var style = window.getComputedStyle(track);
      return parseFloat(style.gap || style.columnGap || '0') || 0;
    }

    function visibleCols() {
      // 2-up only when there's real room; below 800px cards get unreadably narrow.
      return window.matchMedia('(min-width: 800px)').matches ? 2 : 1;
    }

    function sizeItems() {
      var cols = visibleCols();
      var g = gap();
      // getBoundingClientRect avoids subpixel clientWidth rounding that clipped the date.
      var vw = Math.floor(viewport.getBoundingClientRect().width);
      if (vw <= 0) return 0;
      var w;
      if (cols === 2) {
        /* Leave a pixel of slack so subpixel rounding cannot clip the second card. */
        w = Math.floor((vw - g - 2) / 2);
        while (w > 0 && w * 2 + g > vw - 1) w -= 1;
      } else {
        w = Math.max(0, Math.floor(vw) - 1);
      }
      if (w < 1) return 0;
      Array.prototype.forEach.call(track.children, function (el) {
        el.style.flex = '0 0 ' + w + 'px';
        el.style.width = w + 'px';
        el.style.maxWidth = w + 'px';
        el.style.minWidth = w + 'px';
        el.style.boxSizing = 'border-box';
        el.style.overflow = 'visible';
      });
      return w;
    }

    function stepWidth() {
      var w = sizeItems();
      if (!w) return 0;
      return w + gap();
    }

    function setWidth() {
      // One full card set (gap lives between cards, not after the last).
      var step = stepWidth();
      if (!step) return 0;
      return setCount * step - gap();
    }

    function needsNav() {
      return setCount > visibleCols();
    }

    function ensureLoopClones() {
      if (looped || !needsNav()) return;
      cloneCarouselSet(track, originals);
      cloneCarouselSet(track, originals);
      looped = true;
      sizeItems();
      offset = setWidth();
      apply(false);
    }

    function syncNav() {
      var show = needsNav();
      root.classList.toggle('home-reviews__carousel--nav', show);
      if (prevBtn) prevBtn.hidden = !show;
      if (nextBtn) nextBtn.hidden = !show;
      // Force layout so clientWidth includes the arrow columns.
      void viewport.offsetWidth;
      sizeItems();
      if (show) ensureLoopClones();
      else if (!looped) {
        offset = 0;
        apply(false);
      }
    }

    function apply(animate) {
      var x = Math.round(offset);
      if (!animate || reduceMotion) {
        track.style.transition = 'none';
        track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
        void track.offsetWidth;
      } else {
        track.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
        track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
      }
    }

    function normalize() {
      if (!looped) return;
      var set = setWidth();
      if (set <= 0) return;
      while (offset >= set * 2) offset -= set;
      while (offset < set) offset += set;
      apply(false);
    }

    function finishAnim() {
      if (animTimer) {
        window.clearTimeout(animTimer);
        animTimer = null;
      }
      normalize();
      animating = false;
    }

    function step(dir) {
      syncNav();
      if (!needsNav() || animating) return;
      ensureLoopClones();
      var stepPx = stepWidth();
      if (!stepPx) return;
      animating = true;
      offset += dir * stepPx;
      apply(true);
      if (reduceMotion) {
        finishAnim();
        return;
      }
      animTimer = window.setTimeout(finishAnim, ANIM_MS);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      finishAnim();
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    bindSwipe(viewport, function () { step(-1); }, function () { step(1); });

    window.addEventListener(
      'resize',
      function () {
        if (animTimer) {
          window.clearTimeout(animTimer);
          animTimer = null;
        }
        animating = false;
        syncNav();
        if (looped) offset = setWidth();
        else offset = 0;
        apply(false);
      },
      { passive: true }
    );

    syncNav();
    apply(false);
    pinReviewArrows(root, [prevBtn, nextBtn].filter(Boolean));
  }

  /* Keep review arrows on the photo so a taller quote cannot shift them. */
  function pinReviewArrows(root, arrows) {
    if (!root || !arrows.length) return;
    var narrow = window.matchMedia('(max-width: 799px)');
    function place() {
      var i;
      if (!narrow.matches) {
        for (i = 0; i < arrows.length; i++) arrows[i].style.marginTop = '';
        return;
      }
      var photos = root.querySelectorAll('.review-card__photo');
      var photo = null;
      var rect = null;
      for (i = 0; i < photos.length; i++) {
        rect = photos[i].getBoundingClientRect();
        if (rect.height > 0) {
          photo = photos[i];
          break;
        }
      }
      if (!photo || !rect) return;
      var mid = rect.top - root.getBoundingClientRect().top + rect.height / 2;
      for (i = 0; i < arrows.length; i++) {
        var btn = arrows[i];
        if (btn.hidden) continue;
        var h = btn.offsetHeight || 44;
        btn.style.marginTop = Math.max(0, Math.round(mid - h / 2)) + 'px';
      }
    }
    place();
    window.requestAnimationFrame(place);
    window.addEventListener('resize', place, { passive: true });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', place, { once: true });
    }
  }

  /* Review files are not product photos. Keep them off img/video src in the
     HTML Meta's catalog crawler reads, then attach them for shoppers. */
  function revealReviewMedia(scope) {
    var root = scope || document;
    function reviewUrl(value) {
      return value ? value.replace(/\|/g, '.') : '';
    }
    root.querySelectorAll('[data-review-src]').forEach(function (el) {
      var url = reviewUrl(el.getAttribute('data-review-src'));
      if (!url || el.getAttribute('src')) return;
      el.setAttribute('src', url);
    });
    root.querySelectorAll('[data-review-poster]').forEach(function (el) {
      var url = reviewUrl(el.getAttribute('data-review-poster'));
      if (!url || el.getAttribute('poster')) return;
      el.setAttribute('poster', url);
    });
  }

  /* ---- PDP product reviews carousel ------------------------------------ */
  function initProductReviews() {
    document.querySelectorAll('[data-product-reviews]').forEach(function (root) {
      if (root.getAttribute('data-reviews-bound') === 'true') return;
      root.setAttribute('data-reviews-bound', 'true');

      var items = Array.prototype.slice.call(root.querySelectorAll('.product-reviews__item'));
      if (items.length < 2) return;

      var index = 0;
      var activeIdx = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      if (activeIdx >= 0) index = activeIdx;

      var prevBtn = root.querySelector('[data-product-reviews-prev]');
      var nextBtn = root.querySelector('[data-product-reviews-next]');

      function show(i) {
        index = ((i % items.length) + items.length) % items.length;
        items.forEach(function (item, n) {
          item.classList.toggle('is-active', n === index);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () { show(index - 1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { show(index + 1); });
      }
      bindSwipe(
        root.querySelector('[data-product-reviews-track]') || root,
        function () { show(index - 1); },
        function () { show(index + 1); }
      );

      show(index);
      pinReviewArrows(
        root.querySelector('.product-reviews__row') || root,
        [prevBtn, nextBtn].filter(Boolean)
      );
    });
  }

  /* ---- Review card → all-reviews modal (scrollable) -------------------- */
  function openReviewModal(card) {
    var root = document.querySelector('[data-review-modal]');
    if (!root || !card) return;

    var name = card.getAttribute('data-review-name') || '';
    var scroller = root.querySelector('[data-review-modal-scroller]');
    var entries = root.querySelectorAll('[data-review-modal-entry]');
    var target = null;

    entries.forEach(function (entry) {
      entry.classList.remove('is-focused');
      if (name && entry.getAttribute('data-review-modal-entry') === name) {
        target = entry;
      }
    });
    if (!target && entries.length) target = entries[0];
    if (target) target.classList.add('is-focused');

    root.hidden = false;
    if (scroller) scroller.scrollTop = 0;

    requestAnimationFrame(function () {
      root.classList.add('is-open');
      if (target && scroller) {
        // Align clicked review near the top of the scroller, then user can scroll down.
        var top = target.offsetTop - 12;
        scroller.scrollTop = top > 0 ? top : 0;
      }
    });
    document.documentElement.classList.add('review-modal-open');
    var closeBtn = root.querySelector('.review-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeReviewModal() {
    var root = document.querySelector('[data-review-modal]');
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('review-modal-open');
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 220);
  }

  function initReviewModal() {
    var root = document.querySelector('[data-review-modal]');
    if (!root || root.getAttribute('data-review-modal-bound') === 'true') return;
    root.setAttribute('data-review-modal-bound', 'true');

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-review-card]');
      if (card) {
        // Print title links should navigate; everything else opens the modal.
        if (e.target.closest('a[href]')) return;
        e.preventDefault();
        openReviewModal(card);
        return;
      }
      if (e.target.closest('[data-review-modal-close]')) {
        e.preventDefault();
        closeReviewModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        closeReviewModal();
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-review-card]');
      if (!card) return;
      e.preventDefault();
      openReviewModal(card);
    });
  }

  function initSizeGuide() {
    if (document.documentElement.hasAttribute('data-size-guide-bound')) return;
    document.documentElement.setAttribute('data-size-guide-bound', '');

    function guideRoot() {
      return document.querySelector('[data-size-guide]');
    }

    function fit() {
      var root = guideRoot();
      if (!root || root.hidden) return;
      var panel = root.querySelector('[data-size-guide-panel]');
      var sheet = root.querySelector('[data-size-guide-sheet]');
      if (!panel || !sheet) return;
      sheet.style.transform = 'none';
      panel.style.height = '';
      var available = panel.clientHeight;
      var needed = sheet.scrollHeight;
      if (!available || !needed || needed <= available + 1) return;
      var scale = available / needed;
      sheet.style.transform = 'scale(' + scale + ')';
      panel.style.height = Math.floor(needed * scale) + 'px';
    }

    function openGuide(opener) {
      var root = guideRoot();
      if (!root) return;
      root.hidden = false;
      document.documentElement.classList.add('size-guide-open');
      if (opener) root._opener = opener;
      var img = root.querySelector('.size-guide__room');
      if (img && !img.complete) img.addEventListener('load', fit, { once: true });
      window.requestAnimationFrame(function () {
        fit();
        window.requestAnimationFrame(fit);
      });
      var closeBtn = root.querySelector('[data-size-guide-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeGuide() {
      var root = guideRoot();
      if (!root || root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('size-guide-open');
      if (root._opener && root._opener.focus) root._opener.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-size-guide-open]');
      if (opener) {
        e.preventDefault();
        openGuide(opener);
        return;
      }
      if (e.target.closest('[data-size-guide-close]')) {
        closeGuide();
        return;
      }
      var root = guideRoot();
      if (root && e.target === root) closeGuide();
    });

    document.addEventListener(
      'keydown',
      function (e) {
        var root = guideRoot();
        if (!root || root.hidden || e.key !== 'Escape') return;
        e.preventDefault();
        e.stopPropagation();
        closeGuide();
      },
      true
    );

    window.addEventListener('resize', fit);
  }

  /* ---- Write a review (moderated; media never publishes itself) -------- */
  function initWriteReview() {
    var root = document.querySelector('[data-write-review]');
    if (!root || root.getAttribute('data-write-review-bound') === 'true') return;
    root.setAttribute('data-write-review-bound', 'true');

    var form = root.querySelector('form');
    var thanks = root.querySelector('[data-write-review-thanks]');
    var status = root.querySelector('[data-write-review-status]');
    var stars = root.querySelector('[data-review-stars]');
    var fileInput = root.querySelector('[data-review-file]');
    var fileName = root.querySelector('[data-review-file-name]');
    var fileList = root.querySelector('[data-review-file-list]');
    var printSelect = root.querySelector('[data-review-print]');
    var printLink = root.querySelector('[data-review-print-link]');
    var mediaLink = root.querySelector('[data-review-media-link]');
    var lastOpener = null;
    var selectedFiles = [];
    var maxBytes = parseInt(root.getAttribute('data-max-bytes') || '20971520', 10);
    var maxFiles = parseInt(root.getAttribute('data-max-files') || '10', 10);

    function msg(key) {
      return root.getAttribute(key) || '';
    }

    function setStatus(text, isError) {
      if (!status) return;
      status.textContent = text || '';
      status.classList.toggle('is-error', !!isError && !!text);
    }

    function paintStars() {
      if (!stars) return;
      var hover = stars.getAttribute('data-hover');
      var checked = stars.querySelector('input:checked');
      var value = hover || (checked ? checked.value : '0');
      stars.setAttribute('data-rating', value);
    }

    function syncPrintLink() {
      if (!printSelect || !printLink) return;
      var option = printSelect.options[printSelect.selectedIndex];
      printLink.value = option ? option.getAttribute('data-url') || '' : '';
    }

    function resetForm() {
      if (form) {
        form.hidden = false;
        form.reset();
      }
      if (thanks) thanks.hidden = true;
      if (stars) {
        stars.removeAttribute('data-hover');
        stars.setAttribute('data-rating', '0');
      }
      selectedFiles = [];
      renderFiles();
      if (mediaLink) mediaLink.value = '';
      syncPrintLink();
      setStatus('');
    }

    function openWriteReview(opener) {
      lastOpener = opener || document.activeElement;
      if (root.querySelector('[data-review-posted]')) {
        if (form) form.hidden = false;
      } else if (thanks && !thanks.hidden) {
        resetForm();
      }
      if (opener) {
        var title = opener.getAttribute('data-print-title') || '';
        var url = opener.getAttribute('data-print-url') || '';
        if (printSelect && (title || url)) {
          var matched = false;
          Array.prototype.forEach.call(printSelect.options, function (option) {
            if (matched) return;
            if ((url && option.getAttribute('data-url') === url) || (title && option.value === title)) {
              option.selected = true;
              matched = true;
            }
          });
        }
      }
      syncPrintLink();
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.documentElement.classList.add('write-review-open');
      var focusTarget = root.querySelector('input[name="contact[name]"]') || root.querySelector('.write-review__close');
      if (focusTarget) focusTarget.focus();
    }

    function closeWriteReview() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('write-review-open');
      setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 220);
      if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    function mediaUrlFromProperties(properties) {
      if (!properties) return '';
      var keys = Object.keys(properties);
      for (var i = 0; i < keys.length; i++) {
        var value = properties[keys[i]];
        if (typeof value === 'string' && /^https?:\/\//.test(value)) return value;
        if (value && typeof value.url === 'string') return value.url;
      }
      return '';
    }

    function isReviewFile(file) {
      return file && file.type && (file.type.indexOf('image/') === 0 || file.type.indexOf('video/') === 0);
    }

    function renderFiles() {
      if (fileName) fileName.textContent = root.getAttribute('data-media-hint') || '';
      if (!fileList) return;
      fileList.innerHTML = '';
      if (!selectedFiles.length) {
        fileList.hidden = true;
        return;
      }
      var removeLabel = root.getAttribute('data-remove-label') || 'Remove';
      selectedFiles.forEach(function (file, index) {
        var item = document.createElement('li');
        var name = document.createElement('span');
        name.textContent = file.name;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('data-review-file-remove', String(index));
        remove.textContent = removeLabel;
        item.appendChild(name);
        item.appendChild(remove);
        fileList.appendChild(item);
      });
      fileList.hidden = false;
    }

    function uploadMedia(file) {
      var variantId = (root.getAttribute('data-upload-variant') || '').trim();
      if (!variantId) return Promise.reject(new Error('upload'));
      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      body.append('properties[Review media]', file);
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error('upload');
          if (payload && payload.items && payload.items[0]) return payload.items[0];
          return payload;
        });
      }).then(function (item) {
        var url = mediaUrlFromProperties(item && item.properties);
        var key = item && item.key;
        var readCart = url
          ? Promise.resolve(url)
          : fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
              headers: { Accept: 'application/json' }
            }).then(function (r) { return r.json(); }).then(function (cart) {
              var line = (cart.items || []).filter(function (entry) {
                return entry.handle === 'review-upload';
              })[0];
              if (line) {
                key = line.key;
                return mediaUrlFromProperties(line.properties);
              }
              return '';
            });
        return readCart.then(function (found) {
          var remove = key
            ? fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              })
            : Promise.resolve();
          return remove.then(function () {
            if (!found) throw new Error('upload');
            return found;
          });
        });
      });
    }

    if (stars) {
      stars.addEventListener('change', paintStars);
      stars.addEventListener('mouseover', function (e) {
        var label = e.target.closest('.write-review__star');
        if (!label || !stars.contains(label)) return;
        var input = label.querySelector('input');
        if (!input) return;
        stars.setAttribute('data-hover', input.value);
        paintStars();
      });
      stars.addEventListener('mouseleave', function () {
        stars.removeAttribute('data-hover');
        paintStars();
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var incoming = fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
        fileInput.value = '';
        var rejectedType = false;
        var rejectedSize = false;
        var rejectedCount = false;
        incoming.forEach(function (file) {
          if (!isReviewFile(file)) {
            rejectedType = true;
            return;
          }
          if (file.size > maxBytes) {
            rejectedSize = true;
            return;
          }
          if (selectedFiles.length >= maxFiles) {
            rejectedCount = true;
            return;
          }
          selectedFiles.push(file);
        });
        renderFiles();
        if (rejectedCount) setStatus(msg('data-msg-file-count'), true);
        else if (rejectedSize) setStatus(msg('data-msg-file-size'), true);
        else if (rejectedType) setStatus(msg('data-msg-file-type'), true);
        else setStatus('');
      });
    }

    if (fileList) {
      fileList.addEventListener('click', function (e) {
        var button = e.target.closest('[data-review-file-remove]');
        if (!button || !fileList.contains(button)) return;
        var index = parseInt(button.getAttribute('data-review-file-remove'), 10);
        if (isNaN(index)) return;
        selectedFiles.splice(index, 1);
        renderFiles();
        setStatus('');
      });
    }

    if (printSelect) printSelect.addEventListener('change', syncPrintLink);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-write-review-open]');
      if (opener) {
        e.preventDefault();
        openWriteReview(opener);
        return;
      }
      if (e.target.closest('[data-write-review-close]')) {
        e.preventDefault();
        closeWriteReview();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        e.stopPropagation();
        closeWriteReview();
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var honeypot = form.querySelector('[name="contact[company_website]"]');
        if (honeypot && honeypot.value) {
          if (thanks) thanks.hidden = false;
          form.hidden = true;
          return;
        }
        var starInput = form.querySelector('input[name="contact[stars]"]:checked');
        if (!starInput) {
          setStatus(msg('data-msg-rating'), true);
          return;
        }
        var badType = selectedFiles.some(function (file) { return !isReviewFile(file); });
        var badSize = selectedFiles.some(function (file) { return file.size > maxBytes; });
        if (badType) {
          setStatus(msg('data-msg-file-type'), true);
          return;
        }
        if (badSize) {
          setStatus(msg('data-msg-file-size'), true);
          return;
        }
        if (selectedFiles.length > maxFiles) {
          setStatus(msg('data-msg-file-count'), true);
          return;
        }

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.classList.add('is-loading');
        setStatus('');
        syncPrintLink();

        var filesToSend = selectedFiles.slice();
        var send = filesToSend.reduce(function (chain, file) {
          return chain.then(function (urls) {
            return uploadMedia(file).then(function (url) {
              urls.push(url);
              return urls;
            });
          });
        }, Promise.resolve([])).then(function (urls) {
          if (mediaLink) mediaLink.value = urls.join('\n');
        });

        send.then(function () {
          var params = new URLSearchParams();
          var data = new FormData(form);
          data.forEach(function (value, key) {
            if (typeof value === 'string') params.append(key, value);
          });
          return fetch(form.action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'text/html'
            },
            body: params.toString()
          }).then(function (response) {
            return response.text().then(function (html) {
              if (!response.ok || html.indexOf('data-review-posted') === -1) {
                throw new Error('contact');
              }
            });
          });
        }).then(function () {
          form.hidden = true;
          if (thanks) thanks.hidden = false;
          setStatus('');
        }).catch(function (error) {
          if (filesToSend.length && error && error.message === 'upload') setStatus(msg('data-msg-upload'), true);
          else setStatus(msg('data-msg-error'), true);
        }).then(function () {
          if (submitBtn) submitBtn.classList.remove('is-loading');
        });
      });
    }

    if (root.querySelector('[data-review-posted]')) openWriteReview(null);
  }

  function initProcessVideos() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-process-video]').forEach(function (video) {
      if (!reduce) return;
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    revealReviewMedia(document);
    initProcessVideos();
    layoutGridColumns();
    window.addEventListener('resize', scheduleGridLayout, { passive: true });
    initHeader();
    initSimpleMockups(document);
    initProductDynReady(document);
    initGridLazyLoad();
    initCardHover();
    initImageSaveDeterrent();
    initFilter();
    initLightbox();
    initQuantity(document);
    initMaterialsVisuals();
    initProductGallery();
    initProductHero();
    initProduct();
    initRelatedProducts();
    initAboutCarousel();
    initCartDrawer();
    initNewsletterSignup();
    initNewsletterPopup();
    initFloatingCartLift();
    initCartPage();
    initFavoritesCarousel();
    initReviewsCarousel();
    initProductReviews();
    initReviewModal();
    initWriteReview();
    initSizeGuide();
    refreshCart(false);
  });

  // Theme editor: re-init section-scoped behavior when a section is
  // re-rendered. The lightbox is delegated on document, so it needs no re-init.
  document.addEventListener('shopify:section:load', function (event) {
    revealReviewMedia(event.target || document);
    initProcessVideos();
    layoutGridColumns();
    initHeader();
    initSimpleMockups(document);
    initProductDynReady(document);
    initGridLazyLoad();
    initCardHover();
    initFilter();
    initQuantity(document);
    initMaterialsVisuals();
    initProductGallery();
    initProductHero();
    initProduct();
    initRelatedProducts();
    initAboutCarousel();
    initNewsletterSignup();
    initNewsletterPopup();
    initCartPage();
    initFavoritesCarousel();
    initReviewsCarousel();
    initProductReviews();
    initSizeGuide();
  });
})();
